import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Avatar,
  LinearProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Tooltip,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  Alert,
  Snackbar,
  List,
  ListItem,
  ListItemButton,
  ListItemText as MuiListItemText,
  ListItemIcon as MuiListItemIcon,
  Switch,
  FormControlLabel,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import {
  Visibility as ViewIcon,
  TrendingUp as TrendingUpIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  Schedule as ScheduleIcon,
  Assessment as AssessmentIcon,
  Book as BookIcon,
  Apps as AppsIcon,
  School as ClassIcon,
  People as PeopleIcon,
  Home as HomeIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  DragIndicator as DragIndicatorIcon,
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  PlayArrow as PlayArrowIcon,
  Pause as PauseIcon,
  VisibilityOff as VisibilityOffIcon,
  Send as SendIcon,
  CalendarToday as CalendarIcon,
  BarChart as BarChartIcon,
  Folder as FolderIcon,
  Reorder as ReorderIcon,
  Settings as SettingsIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon2,
  PlayArrow as PlayArrowIcon2,
  Pause as PauseIcon2,
  CheckCircle as CheckCircleIcon2,
  Cancel as CancelIcon,
  KeyboardArrowUp as ArrowUpIcon,
  KeyboardArrowDown as ArrowDownIcon,
  ExpandMore as ExpandMoreIcon,
  ViewList as ViewListIcon,
  Assignment as AssignmentIcon
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../../../components/Navbar';
import { createAllPhaseMenuGroups } from '../../../../utils/createAllPhaseMenuGroups';
import axiosInstance from '../../../../utils/axiosInstance';
import config from '../../../../config.json';
import url from '../../../../url.json';
import io from "socket.io-client";
import OwlMascot from '../../../../assets/貓頭鷹博士_雙手.gif';
import TaskBlocksView from './TaskBlocksView';

// 假資料 - 任務指派數據
const mockTaskDispatchData = {
  applicationInfo: {
    id: 1,
    title: '六年級一班 - 力與運動探究',
    lessonPackage: '第二章:力與運動探究',
    className: '六年級一班',
    startDate: '2024-03-01',
    endDate: '2024-03-15',
    status: 'active'
  },
  
  // 任務 × 小組矩陣視圖（進度追蹤）
  taskGroupMatrix: {
    groups: [
      { id: 1, name: '第1組', members: ['vbx94', 'vbx95', 'vbx96'] },
      { id: 2, name: '第2組', members: ['vbx97', 'vbx98', 'vbx99'] },
      { id: 3, name: '第3組', members: ['vbx100', 'vbx101', 'vbx102'] }
    ],
    tasks: [
      { 
        id: 1, 
        title: '實驗紀錄', 
        description: '記錄溶解實驗的步驟和觀察結果',
        tag: '紀錄',
        requiresSubmission: false
      },
      { 
        id: 2, 
        title: '實驗設計', 
        description: '設計不同物質的溶解實驗方案',
        tag: '實驗',
        requiresSubmission: true
      },
      { 
        id: 3, 
        title: '結果分析', 
        description: '分析實驗數據並得出結論',
        tag: '紀錄',
        requiresSubmission: true
      },
      { 
        id: 4, 
        title: '預測活動', 
        description: '預測不同條件下物質的溶解速度',
        tag: '想法',
        requiresSubmission: false
      },
      { 
        id: 5, 
        title: '反思總結', 
        description: '反思學習過程中的收穫和疑問',
        tag: '想法',
        requiresSubmission: true
      }
    ],
    // 矩陣狀態：taskId_groupId -> status
    matrixStatus: {
      '1_1': { status: 'completed', progress: null, studentResult: null },
      '1_2': { status: 'completed', progress: null, studentResult: '通過這次學習，我們更深入理解了溶解的科學原理，也學會了如何設計和進行科學實驗。我們還發現科學就在我們身邊！' },
      '1_3': { status: 'completed', progress: null, studentResult: null },
      '2_1': { status: 'completed', progress: null, studentResult: null },
      '2_2': { status: 'in_progress', progress: '0/1', studentResult: null },
      '2_3': { status: 'completed', progress: '1/1', studentResult: '我們觀察到糖在熱水中溶解得比冷水中快，這可能是因為溫度影響了分子運動速度。' },
      '3_1': { status: 'in_progress', progress: '0/1', studentResult: null },
      '3_2': { status: 'dispatched', progress: null, studentResult: null },
      '3_3': { status: 'completed', progress: '1/1', studentResult: '我們設計了三個實驗：1) 比較不同物質的溶解速度 2) 測試溫度對溶解的影響 3) 觀察攪拌的作用。實驗結果顯示鹽比糖溶解得更快。' },
      '4_1': { status: 'dispatched', progress: '1/1', studentResult: '根據實驗數據，我們發現溶解速度與溫度成正比，與攪拌頻率也成正比。這證實了我們的假設。' },
      '4_2': { status: 'dispatched', progress: '0/1', studentResult: null },
      '4_3': { status: 'not_dispatched', progress: null, studentResult: null },
      '5_1': { status: 'not_dispatched', progress: '1/1', studentResult: null },
      '5_2': { status: 'not_dispatched', progress: '1/1', studentResult: '我們發現溶解不僅在廚房有用，在醫療上也很重要，比如輸液就是利用溶解原理。' },
      '5_3': { status: 'not_dispatched', progress: '0/1', studentResult: null }
    }
  }
};

export default function ClassApplicationTaskDispatch() {
  const navigate = useNavigate();
  const { id: courseDispatchId } = useParams(); // 從路由參數 :id 獲取
  const [activeTab, setActiveTab] = useState(0);
  const [taskDispatchData, setTaskDispatchData] = useState(null);
  const [currentApplication, setCurrentApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // 任務指派相關狀態
  const [openCreateTaskDialog, setOpenCreateTaskDialog] = useState(false);
  const [openManageTaskDialog, setOpenManageTaskDialog] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [isDispatching, setIsDispatching] = useState(false); // 防止重複提交
  const [allowCrossGroupView, setAllowCrossGroupView] = useState(true); // 是否允許學生跨組查看
  
  // WebSocket 相關狀態
  const [ws, setSocket] = useState(null);

  // 獲取課程派發真實數據
  const fetchCourseDispatchData = async () => {
    if (!courseDispatchId) return;
    
    try {
      console.log('🔄 [Teacher] fetchCourseDispatchData: 開始獲取數據');
      setLoading(true);
      setError(null);
      
      // 調用後端API獲取課程派發詳情
      const response = await axiosInstance.get(`${config.getCourseDispatchDetail}${courseDispatchId}/detail`);
      
      if (response.data.success) {
        console.log('✅ [Teacher] fetchCourseDispatchData: 數據獲取成功');
        console.log('  - 任務數量:', response.data.data?.taskGroupMatrix?.tasks?.length || 0);
        console.log('  - 小組數量:', response.data.data?.taskGroupMatrix?.groups?.length || 0);
        console.log('  - 狀態數量:', Object.keys(response.data.data?.taskGroupMatrix?.matrixStatus || {}).length);
        
        // 記錄狀態詳情用於調試
        const matrixStatus = response.data.data?.taskGroupMatrix?.matrixStatus || {};
        const statusCounts = {};
        Object.entries(matrixStatus).forEach(([key, value]) => {
          const status = value.status || 'unknown';
          statusCounts[status] = (statusCounts[status] || 0) + 1;
          // 記錄前5個狀態詳情
          if (Object.keys(statusCounts).length <= 5) {
            console.log(`  - 狀態 ${key}:`, value.status, value.updated_at ? `(更新時間: ${value.updated_at})` : '');
          }
        });
        console.log('  - 狀態分布:', statusCounts);
        
        setTaskDispatchData(response.data.data);
        setCurrentApplication(response.data.data.applicationInfo);
        
        // 獲取課程派發的跨組查看設定（從 applicationInfo 中獲取，因為已經在 fetchCourseDispatchData 中獲取了）
        if (response.data.data.applicationInfo) {
          const applicationInfo = response.data.data.applicationInfo;
          setAllowCrossGroupView(applicationInfo.allow_cross_group_view !== false);
        }
      } else {
        console.error('❌ [Teacher] fetchCourseDispatchData: 數據獲取失敗', response.data.message);
        setError(response.data.message || '獲取課程數據失敗');
      }
      
    } catch (error) {
      console.error('❌ [Teacher] fetchCourseDispatchData: 獲取課程派發數據錯誤:', error);
      setError('獲取課程數據失敗');
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '獲取課程數據失敗', 
        severity: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('🔄 [Teacher] 初始化：獲取課程派發數據');
    fetchCourseDispatchData();
  }, [courseDispatchId]);

  // WebSocket 初始化和監聽
  useEffect(() => {
    if (courseDispatchId) {
      // 初始化 WebSocket 連接
      const socket = io.connect(url.socketioHost, { path: '/s/socket.io' });
      setSocket(socket);

      // 監聽連接事件
      socket.on('connect', () => {
        console.log('🔗 [Teacher WebSocket] 已連接到服務器');
      });

      // 監聽任務狀態更新事件
      socket.on(`task-status-updated-${courseDispatchId}`, async (data) => {
        console.log('🔔 [Teacher WebSocket] 收到任務狀態更新事件');
        console.log('  - 完整數據:', data);
        console.log('  - 任務 ID:', data.task_id);
        console.log('  - 小組 ID:', data.group_id);
        console.log('  - 新狀態:', data.status);
        
        // 更新本地狀態
        await handleTaskStatusUpdate(data);
      });

      // 監聽新節點事件（當學生連線到任務節點時）
      socket.on(`node-recieve-${courseDispatchId}`, async (body) => {
        console.log('🔔 [Teacher WebSocket] 收到新節點事件');
        console.log('  - 節點類型:', body.node_type);
        console.log('  - 節點標題:', body.title);
        console.log('  - 完整節點資料:', body);
        
        // 如果節點有連線到任務節點（parent_node_id 存在且有 task_id），可能需要更新任務狀態
        // 注意：所有類型的節點連線都應該觸發狀態更新，不只是 reply 類型
        if (body.parent_node_id && (body.task_id || body.Task?.id)) {
          console.log('💡 [Teacher WebSocket] 檢測到學生連線到任務節點，可能需要更新任務狀態');
          // 嘗試直接更新對應任務的小組狀態為 in_progress（若取得 task_id 與 group_id）
          const taskIdRaw = body.task_id || body.Task?.id;
          const groupIdRaw = body.group_id || body.Group?.id;
          const taskId = taskIdRaw ? parseInt(taskIdRaw, 10) : null;
          const groupId = groupIdRaw ? parseInt(groupIdRaw, 10) : null;
          if (taskId && groupId && !Number.isNaN(taskId) && !Number.isNaN(groupId)) {
            // 檢查當前狀態，如果已經是 completed，不應該更新為 in_progress
            const currentStatus = taskDispatchData?.taskGroupMatrix?.matrixStatus?.[`${taskId}_${groupId}`]?.status;
            if (currentStatus === 'completed') {
              console.log('⚠️ [Teacher WebSocket] 任務狀態已是 completed，不應該被覆蓋為 in_progress，跳過更新');
              return;
            }
            
            await handleTaskStatusUpdate({
              task_id: taskId,
              group_id: groupId,
              status: 'in_progress',
              updated_by: body.author_id,
              updated_at: new Date().toISOString(),
              submission_content: body.content || ''
            });
          } else {
            console.log('⚠️ [Teacher WebSocket] 連線事件缺少 task_id 或 group_id，無法即時更新矩陣');
            console.log('  - taskIdRaw:', taskIdRaw, 'groupIdRaw:', groupIdRaw);
            // 後備方案：短暫延遲後刷新一次資料，避免漏更新
            // 注意：這可能會覆蓋WebSocket更新的狀態，但因為缺少task_id或group_id，無法精確更新
            setTimeout(() => {
              console.log('🔄 [Teacher WebSocket] 後備方案：重新獲取數據');
              fetchCourseDispatchData();
            }, 1000);
          }
        }
      });

      // 清理函數
      return () => {
        console.log('🔌 [Teacher WebSocket] 斷開連接');
        socket.disconnect();
      };
    }
  }, [courseDispatchId]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // 處理任務狀態更新（WebSocket 觸發）
  const handleTaskStatusUpdate = async (data) => {
    try {
      // 處理狀態轉換：如果收到 submitted 狀態，轉換為 completed
      let processedStatus = data.status;
      if (data.status === 'submitted') {
        processedStatus = 'completed';
        console.log('🔄 [Teacher] 狀態轉換: submitted -> completed');
      }
      
      console.log('🔄 [Teacher] 處理任務狀態更新');
      console.log('  - 任務ID:', data.task_id);
      console.log('  - 小組ID:', data.group_id);
      console.log('  - 原始狀態:', data.status);
      console.log('  - 處理後狀態:', processedStatus);
      
      // 直接更新本地狀態，避免重新獲取數據
      setTaskDispatchData(prevData => {
        if (!prevData || !prevData.taskGroupMatrix) return prevData;
        
        const key = `${data.task_id}_${data.group_id}`;
        const currentStatus = prevData.taskGroupMatrix.matrixStatus[key]?.status;
        
        console.log('🔍 [Teacher] 狀態更新調試:');
        console.log('  - 狀態鍵:', key);
        console.log('  - 當前狀態:', currentStatus);
        console.log('  - 新狀態:', data.status);
        console.log('  - 更新者:', data.updated_by);
        
        // 重要：如果當前狀態是 completed，不應該被覆蓋為 in_progress
        // 已完成後不應該再變回進行中
        if (currentStatus === 'completed' && processedStatus === 'in_progress') {
          console.log('⚠️ [Teacher] 任務狀態已是 completed，不應該被覆蓋為 in_progress，跳過更新');
          return prevData; // 保持原狀態不變
        }
        
        // 優化：如果當前狀態已經是 in_progress，且新狀態也是 in_progress，跳過更新（減少資料流）
        // 只有在狀態變為 completed 時才需要更新
        if (currentStatus === 'in_progress' && processedStatus === 'in_progress') {
          console.log('⏭️ [Teacher] 任務狀態已是 in_progress，無需重複更新，跳過（減少資料流）');
          return prevData; // 保持原狀態不變
        }
        
        const updatedMatrixStatus = {
          ...prevData.taskGroupMatrix.matrixStatus,
          [key]: {
            ...prevData.taskGroupMatrix.matrixStatus[key],
            status: processedStatus,
            updated_at: data.updated_at,
            updated_by: data.updated_by,
            // 添加提交內容信息
            submission_content: data.submission_content || prevData.taskGroupMatrix.matrixStatus[key]?.submission_content,
            studentResult: data.submission_content || prevData.taskGroupMatrix.matrixStatus[key]?.studentResult, // 修復：同時設置 studentResult
            group_members: data.group_members || prevData.taskGroupMatrix.matrixStatus[key]?.group_members
          }
        };
        
        console.log('✅ [Teacher] 更新本地狀態:', key, '->', processedStatus);
        
        return {
          ...prevData,
          taskGroupMatrix: {
            ...prevData.taskGroupMatrix,
            matrixStatus: updatedMatrixStatus
          }
        };
      });
      
      // 顯示通知
      const statusText = getStatusText(data.status);
      
      // 從更新後的狀態中獲取任務和小組信息
      setTaskDispatchData(prevData => {
        if (!prevData || !prevData.taskGroupMatrix) return prevData;
        
        const task = prevData.taskGroupMatrix.tasks?.find(t => t.id === data.task_id);
        const group = prevData.taskGroupMatrix.groups?.find(g => g.id === data.group_id);
        
        // 顯示通知
        setSnackbar({
          open: true,
          message: `📢 任務狀態更新\n\n📋 任務：${task?.title || '未知任務'}\n👥 小組：${group?.name || '未知小組'}\n🔄 狀態：${statusText}`,
          severity: 'info'
        });
        
        return prevData; // 不修改數據，只是為了獲取任務和小組信息
      });
      
    } catch (error) {
      console.error('❌ [Teacher] 處理任務狀態更新失敗:', error);
    }
  };

  // 任務指派處理函數
  const handleTaskSelect = (taskId) => {
    setSelectedTasks(prev => 
      prev.includes(taskId) 
        ? prev.filter(id => id !== taskId)
        : [...prev, taskId]
    );
  };

  const handleGroupSelect = (groupId) => {
    setSelectedGroups(prev => 
      prev.includes(groupId) 
        ? prev.filter(id => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleDispatchTasks = async () => {
    if (selectedTasks.length === 0 || selectedGroups.length === 0) {
      setSnackbar({ open: true, message: '請選擇任務和小組', severity: 'warning' });
      return;
    }
    
    // 防止重複提交
    if (isDispatching) {
      console.warn('⚠️ [handleDispatchTasks] 任務正在派發中，忽略重複請求');
      return;
    }
    
    try {
      setIsDispatching(true); // 設置派發中狀態
      console.log('🔄 [handleDispatchTasks] 開始派發任務...');
      
      // 為每個選中的任務更新指派的小組
      const dispatchPromises = selectedTasks.map(taskId => {
        // 獲取當前任務的已指派小組，並合併新選中的小組
        const currentTask = taskDispatchData.taskGroupMatrix.tasks.find(t => t.id === taskId);
        const currentAssignedGroups = currentTask?.assigned_groups || [];
        
        // 合併現有的指派小組和新選中的小組
        const newAssignedGroups = [...new Set([...currentAssignedGroups, ...selectedGroups])];
        
        return axiosInstance.put(`${config.assignApplicationTask}${taskId}/assign`, {
          assigned_groups: newAssignedGroups
        });
      });
      
      const results = await Promise.all(dispatchPromises);
      
      // 檢查是否有生成節點
      const totalNodesGenerated = results.reduce((sum, result) => {
        return sum + (result.data?.data?.generated_nodes || 1);
      }, 0);
      
      // 重新獲取數據以確保狀態同步
      await fetchCourseDispatchData();
      
      // 獲取指派詳情
      const selectedTaskNames = selectedTasks.map(taskId => {
        const task = taskDispatchData.taskGroupMatrix.tasks.find(t => t.id === taskId);
        return task ? task.title : `任務 ${taskId}`;
      });
      
      const selectedGroupNames = selectedGroups.map(groupId => {
        const group = taskDispatchData.taskGroupMatrix.groups.find(g => g.id === groupId);
        return group ? group.name : `小組 ${groupId}`;
      });
      
      setSnackbar({ 
        open: true, 
        message: `✅ 任務指派成功！\n\n📋 已指派任務：${selectedTaskNames.join(', ')}\n👥 指派對象：${selectedGroupNames.join(', ')}\n🎯 生成的節點：${totalNodesGenerated} 個（公告 + 想法牆節點）\n\n💡 學生現在可以在想法牆中看到任務公告了！`, 
        severity: 'success' 
      });
      setSelectedTasks([]);
      setSelectedGroups([]);
      
    } catch (error) {
      console.error('指派任務錯誤:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '任務指派失敗，請重試', 
        severity: 'error' 
      });
    } finally {
      setIsDispatching(false); // 重置派發中狀態
      console.log('✅ [handleDispatchTasks] 派發流程結束');
    }
  };

  const handleCellClick = async (taskId, groupId, newStatus = null) => {
    const key = `${taskId}_${groupId}`;
    const currentStatus = taskDispatchData.taskGroupMatrix.matrixStatus[key]?.status || 'not_dispatched';
    
    // 如果沒有指定新狀態，使用原來的邏輯
    if (!newStatus) {
      switch (currentStatus) {
        case 'not_dispatched':
          newStatus = 'dispatched';
          break;
        case 'dispatched':
          newStatus = 'in_progress';
          break;
        case 'in_progress':
          newStatus = 'completed';
          break;
        case 'completed':
          // 已完成的任務不允許變回排程（取消派發）
          setSnackbar({ 
            open: true, 
            message: '⚠️ 已完成的任務無法取消派發', 
            severity: 'warning' 
          });
          return;
        default:
          newStatus = 'dispatched';
      }
    }

    try {
      console.log('🔄 [Teacher] 手動更新任務狀態');
      console.log('  - 任務ID:', taskId);
      console.log('  - 小組ID:', groupId);
      console.log('  - 當前狀態:', currentStatus);
      console.log('  - 新狀態:', newStatus);
      
      // 獲取當前任務的已指派小組
      const currentTask = taskDispatchData.taskGroupMatrix.tasks.find(t => t.id === taskId);
      const currentAssignedGroups = currentTask?.assigned_groups || [];
      
      if (newStatus === 'not_dispatched') {
        // 如果是取消指派，更新 assigned_groups
        const newAssignedGroups = currentAssignedGroups.filter(id => id !== groupId);
        
        await axiosInstance.put(`${config.assignApplicationTask}${taskId}/assign`, {
          assigned_groups: newAssignedGroups
        });
        
        setSnackbar({ 
          open: true, 
          message: '✅ 任務已取消指派給該小組', 
          severity: 'success' 
        });
      } else if (newStatus === 'dispatched' && currentStatus === 'not_dispatched') {
        // 如果是從排程派發到學生方（從排程變為已派發），更新 assigned_groups 並設置狀態為已派發
        const newAssignedGroups = [...new Set([...currentAssignedGroups, groupId])];
        
        console.log('派發任務:', {
          taskId,
          groupId,
          currentAssignedGroups,
          newAssignedGroups,
          url: `${config.assignApplicationTask}${taskId}/assign`
        });
        
        const response = await axiosInstance.put(`${config.assignApplicationTask}${taskId}/assign`, {
          assigned_groups: newAssignedGroups
        });
        
        console.log('派發任務響應:', response.data);
        
        // 更新任務狀態為已派發（派發到學生方）
        await axiosInstance.put(`${config.updateTaskProgressStatus}${taskId}/progress-status`, {
          status: 'dispatched',
          group_id: groupId
        });
        
        // 立刻更新本地矩陣狀態為已指派，避免等待重新抓取資料
        setTaskDispatchData(prevData => {
          if (!prevData || !prevData.taskGroupMatrix) return prevData;
          const key = `${taskId}_${groupId}`;
          const updatedMatrixStatus = {
            ...prevData.taskGroupMatrix.matrixStatus,
            [key]: {
              ...prevData.taskGroupMatrix.matrixStatus[key],
              status: 'dispatched',
              updated_at: new Date().toISOString(),
              updated_by: sessionStorage.getItem('userId') || localStorage.getItem('userId') || 'teacher'
            }
          };
          return {
            ...prevData,
            taskGroupMatrix: {
              ...prevData.taskGroupMatrix,
              matrixStatus: updatedMatrixStatus
            }
          };
        });

        setSnackbar({ 
          open: true, 
          message: '✅ 任務已派發給該小組', 
          severity: 'success' 
        });
      } else if ((newStatus === 'dispatched' && currentStatus !== 'not_dispatched') || newStatus === 'in_progress' || newStatus === 'completed') {
        // 如果是更新進度狀態 (dispatched → in_progress → completed)
        // 使用新的進度狀態更新 API
        console.log(`🔄 [Teacher] 調用 updateTaskProgressStatus API`);
        console.log(`  - 任務ID: ${taskId}`);
        console.log(`  - 小組ID: ${groupId}`);
        console.log(`  - 新狀態: ${newStatus}`);
        
        const response = await axiosInstance.put(`${config.updateTaskProgressStatus}${taskId}/progress-status`, {
          status: newStatus,
          group_id: groupId
        });
        
        console.log(`✅ [Teacher] API 響應:`, response.data);
        
        const statusText = getStatusText(newStatus);
        setSnackbar({ 
          open: true, 
          message: `✅ 任務進度已更新為：${statusText}`, 
          severity: 'success' 
        });
        
        // 直接更新本地狀態，避免重新獲取數據覆蓋 WebSocket 更新
        setTaskDispatchData(prevData => {
          if (!prevData || !prevData.taskGroupMatrix) return prevData;
          
          const key = `${taskId}_${groupId}`;
          const currentUserId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
          const updatedMatrixStatus = {
            ...prevData.taskGroupMatrix.matrixStatus,
            [key]: {
              ...prevData.taskGroupMatrix.matrixStatus[key],
              status: newStatus,
              updated_at: new Date().toISOString(),
              updated_by: currentUserId
            }
          };
          
          console.log(`✅ [Teacher] 更新本地狀態: ${key} -> ${newStatus}`);
          
          return {
            ...prevData,
            taskGroupMatrix: {
              ...prevData.taskGroupMatrix,
              matrixStatus: updatedMatrixStatus
            }
          };
        });
        
        // 重新獲取數據以確保狀態同步
        setTimeout(() => {
          console.log(`🔄 [Teacher] 重新獲取數據以確保狀態同步`);
          fetchCourseDispatchData();
        }, 500);
      }
      
      // 如果 WebSocket 可用，發送狀態更新事件給其他用戶
      if (ws) {
        ws.emit('task-status-updated', {
          task_id: taskId,
          group_id: groupId,
          status: newStatus,
          updated_by: 'teacher',
          updated_at: new Date().toISOString()
        });
      }
      
    } catch (error) {
      console.error('❌ [Teacher] 更新任務狀態錯誤:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '任務狀態更新失敗', 
        severity: 'error' 
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'not_dispatched': return '#f5f5f5';
      case 'dispatched': return '#e3f2fd';
      case 'in_progress': return '#fff3e0';
      case 'completed': return '#e8f5e8';
      default: return '#f5f5f5';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'not_dispatched': return '排程';
      case 'dispatched': return '已派發';
      case 'in_progress': return '進行中';
      case 'completed': return '已完成';
      default: return '排程';
    }
  };

  const matrixData = taskDispatchData?.taskGroupMatrix;
  const matrixStatus = matrixData?.matrixStatus || {};
  const matrixGroups = matrixData?.groups || [];
  const matrixTasks = matrixData?.tasks || [];

  const progressOverview = useMemo(() => {
    const summary = {
      not_dispatched: 0,
      dispatched: 0,
      in_progress: 0,
      completed: 0,
      total: 0
    };
    Object.values(matrixStatus).forEach((cell) => {
      if (!cell) return;
      summary.total += 1;
      const status = cell.status || 'not_dispatched';
      if (summary[status] !== undefined) {
        summary[status] += 1;
      }
    });
    return summary;
  }, [matrixStatus]);

  const groupsNeedingAttention = useMemo(() => {
    const groupNameMap = new Map(
      matrixGroups.map((group, index) => [
        String(group.id ?? index + 1),
        group.name || group.groupName || `第${index + 1}組`
      ])
    );
    const attentionSet = new Set();
    Object.entries(matrixStatus).forEach(([key, cell]) => {
      if (!cell || !cell.status || cell.status === 'completed') return;
      const [, groupId] = key.split('_');
      attentionSet.add(String(groupId));
    });
    return Array.from(attentionSet).map((groupId) => groupNameMap.get(groupId) || `第${groupId}組`);
  }, [matrixGroups, matrixStatus]);

  const pendingTaskTitles = useMemo(() => {
    const pendingTaskIds = new Set();
    Object.entries(matrixStatus).forEach(([key, cell]) => {
      if (!cell || cell.status === 'completed') return;
      if (cell.status === 'not_dispatched' || cell.status === 'dispatched') {
        const [taskId] = key.split('_');
        pendingTaskIds.add(Number(taskId));
      }
    });
    return matrixTasks
      .filter((task) => pendingTaskIds.has(Number(task.id)))
      .map((task) => task.title || `任務 #${task.id}`);
  }, [matrixStatus, matrixTasks]);

  const completionRate = useMemo(() => (
    progressOverview.total
      ? Math.round((progressOverview.completed / progressOverview.total) * 100)
      : 0
  ), [progressOverview]);

  const guidanceMessages = useMemo(() => {
    const messages = [];
    if (pendingTaskTitles.length > 0) {
      const preview = pendingTaskTitles.slice(0, 3).join('、');
      messages.push(
        `還有 ${pendingTaskTitles.length} 個任務尚未全數派達：${preview}${pendingTaskTitles.length > 3 ? '⋯' : ''}`
      );
    }
    if (groupsNeedingAttention.length > 0) {
      const preview = groupsNeedingAttention.slice(0, 3).join('、');
      messages.push(
        `提醒 ${groupsNeedingAttention.length} 個小組尚未完成所有任務：${preview}${groupsNeedingAttention.length > 3 ? '⋯' : ''}`
      );
    }
    if (messages.length === 0) {
      messages.push('全部任務都在掌握中！可以專注觀察學生輸出或切換到儀表板。');
    }
    return messages;
  }, [pendingTaskTitles, groupsNeedingAttention]);

  // A-3: 使用分層架構選單
  const allPhaseMenuGroups = createAllPhaseMenuGroups('implementation', 'task-dispatch', navigate, courseDispatchId);

  // 加載狀態
  if (loading) {
    return (
      <div className="teacher-layout class-application-tasks-container">
        <div className="main-content-v2">
          <Navbar 
            allPhaseMenuGroups={allPhaseMenuGroups}
            currentPhase="implementation"
            currentCourseId={courseDispatchId}
            onPhaseChange={(phase) => {
              if (phase === 'preparation') {
                navigate('/teacher/preparation');
              } else if (phase === 'implementation') {
                navigate('/teacher/implementation');
              } else if (phase === 'diagnosis') {
                navigate('/teacher/diagnosis');
              }
            }}
            onCourseChange={(newCourseId) => {
              const currentPath = window.location.pathname;
              const newPath = currentPath.replace(/\/\d+(\/|$)/, `/${newCourseId}$1`);
              navigate(newPath);
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ ml: 2 }}>載入課程資料中...</Typography>
          </Box>
        </div>
      </div>
    );
  }

  // 錯誤狀態
  if (error) {
    return (
      <div className="teacher-layout class-application-tasks-container">
        <div className="main-content-v2">
          <Navbar 
            allPhaseMenuGroups={allPhaseMenuGroups}
            currentPhase="implementation"
            currentCourseId={courseDispatchId}
            onPhaseChange={(phase) => {
              if (phase === 'preparation') {
                navigate('/teacher/preparation');
              } else if (phase === 'implementation') {
                navigate('/teacher/implementation');
              } else if (phase === 'diagnosis') {
                navigate('/teacher/diagnosis');
              }
            }}
            onCourseChange={(newCourseId) => {
              const currentPath = window.location.pathname;
              const newPath = currentPath.replace(/\/\d+(\/|$)/, `/${newCourseId}$1`);
              navigate(newPath);
            }}
          />
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
            <Button onClick={fetchCourseDispatchData} sx={{ ml: 2 }}>
              重新載入
            </Button>
          </Alert>
        </div>
      </div>
    );
  }

  // 沒有數據
  if (!taskDispatchData || !currentApplication) {
    return (
      <div className="teacher-layout class-application-tasks-container">
        <div className="main-content-v2">
          <Navbar 
            allPhaseMenuGroups={allPhaseMenuGroups}
            currentPhase="implementation"
            currentCourseId={courseDispatchId}
            onPhaseChange={(phase) => {
              if (phase === 'preparation') {
                navigate('/teacher/preparation');
              } else if (phase === 'implementation') {
                navigate('/teacher/implementation');
              } else if (phase === 'diagnosis') {
                navigate('/teacher/diagnosis');
              }
            }}
            onCourseChange={(newCourseId) => {
              const currentPath = window.location.pathname;
              const newPath = currentPath.replace(/\/\d+(\/|$)/, `/${newCourseId}$1`);
              navigate(newPath);
            }}
          />
          <Alert severity="warning" sx={{ mt: 2 }}>
            找不到課程資料，請確認課程ID是否正確
          </Alert>
        </div>
      </div>
    );
  }

  return (
    <div className="teacher-layout class-application-tasks-container">
      <div className="main-content-v2">
        <Navbar 
          allPhaseMenuGroups={allPhaseMenuGroups}
          currentPhase="implementation"
          currentCourseId={courseDispatchId}
          onPhaseChange={(phase) => {
            if (phase === 'preparation') {
              navigate('/teacher/preparation');
            } else if (phase === 'implementation') {
              navigate('/teacher/implementation');
            } else if (phase === 'diagnosis') {
              navigate('/teacher/diagnosis');
            }
          }}
          onCourseChange={(newCourseId) => {
            const currentPath = window.location.pathname;
            const newPath = currentPath.replace(/\/\d+(\/|$)/, `/${newCourseId}$1`);
            navigate(newPath);
          }}
        />
        
        <div className="class-header-row">
          <h1 className="main-title">
            任務管理
            {currentApplication && (
              <Typography variant="subtitle1" color="text.secondary" sx={{ ml: 1, display: 'inline' }}>
                {currentApplication.title || currentApplication.activity_name || currentApplication.lessonPackage || '課程'}
              </Typography>
            )}
          </h1>
        </div>

        {/* 任務管理標籤 */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs value={activeTab} onChange={handleTabChange} sx={{ flex: 1 }}>
            <Tab 
              label="任務進度" 
              icon={<BarChartIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="任務清單" 
              icon={<EditIcon />} 
              iconPosition="start"
            />
            {/* 暫時隱藏指派任務tab */}
            {/* <Tab 
              label="指派任務" 
              icon={<SendIcon />} 
              iconPosition="start"
            /> */}
            <Tab 
              label="任務成果" 
              icon={<FolderIcon />} 
              iconPosition="start"
            />
          </Tabs>
          <FormControlLabel
            control={
              <Switch
                checked={allowCrossGroupView}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  setAllowCrossGroupView(newValue);
                  try {
                    const response = await axiosInstance.put(`${config.updateCourseDispatchStatus}${courseDispatchId}/settings`, {
                      allow_cross_group_view: newValue
                    });
                    console.log('✅ [Teacher] 更新跨組查看設定成功:', response.data);
                    
                    // 從響應中讀取實際更新的值，確保狀態同步
                    if (response.data.success && response.data.data && typeof response.data.data.allow_cross_group_view === 'boolean') {
                      const actualValue = response.data.data.allow_cross_group_view;
                      console.log('  - 從響應中讀取的值:', actualValue);
                      setAllowCrossGroupView(actualValue);
                    } else {
                      // 如果響應中沒有值，使用 newValue
                      console.log('  - 響應中沒有值，使用 newValue:', newValue);
                      setAllowCrossGroupView(newValue);
                    }
                    
                    setSnackbar({
                      open: true,
                      message: response.data.data?.allow_cross_group_view ? '已允許學生查看其他小組' : '已禁止學生查看其他小組',
                      severity: 'success'
                    });
                  } catch (error) {
                    console.error('❌ [Teacher] 更新跨組查看設定失敗:', error);
                    console.error('  - 錯誤詳情:', error.response?.data);
                    setAllowCrossGroupView(!newValue); // 回滾狀態
                    setSnackbar({
                      open: true,
                      message: '更新設定失敗，請重試',
                      severity: 'error'
                    });
                  }
                }}
              />
            }
            label="允許學生查看其他小組"
            sx={{ ml: 2, mr: 1 }}
          />
        </Box>

        {/* 標籤內容 */}
        <Box sx={{ mt: 3 }}>
          {activeTab === 0 && taskDispatchData?.taskGroupMatrix && (
            <TaskBlocksView
              data={taskDispatchData.taskGroupMatrix}
              courseDispatchId={courseDispatchId}
              onTaskReorder={async (draggedTaskId, targetTaskId, draggedGroupId, targetGroupId) => {
                // 實現組別專屬的任務重新排序
                try {
                  // 獲取該組的所有任務並重新計算順序
                  const groupTasks = taskDispatchData.taskGroupMatrix.tasks.filter(task => {
                    const assignedGroups = task.assigned_groups || [];
                    return assignedGroups.includes(targetGroupId);
                  });

                  // 構建任務順序數組
                  const taskOrders = groupTasks.map((task, index) => ({
                    task_id: task.id,
                    order_index: index
                  }));

                  // 調用後端 API 更新任務順序
                  await axiosInstance.put(
                    `/api/application-tasks/course-dispatch/${courseDispatchId}/group/${targetGroupId}/task-order`,
                    { task_orders: taskOrders }
                  );

                  await fetchCourseDispatchData();
                } catch (error) {
                  console.error('重新排序任務錯誤:', error);
                }
              }}
              onTaskDelete={async (taskId, groupId) => {
                // TODO: 實現任務刪除邏輯
                console.log('刪除任務:', { taskId, groupId });
                await fetchCourseDispatchData();
              }}
              onTaskAdd={async (groupId) => {
                // TODO: 實現任務添加邏輯
                console.log('添加任務到組:', groupId);
              }}
              onCellClick={handleCellClick}
              getStatusColor={getStatusColor}
              getStatusText={getStatusText}
              onDataChange={fetchCourseDispatchData}
            />
          )}
          
          {activeTab === 1 && (
            <TaskListView 
              data={taskDispatchData.taskGroupMatrix}
              courseDispatchId={courseDispatchId}
              onCreateTask={() => setOpenCreateTaskDialog(true)}
              onManageTask={() => setOpenManageTaskDialog(true)}
              onDataChange={fetchCourseDispatchData}
            />
          )}
          
          {/* 暫時隱藏指派任務tab */}
          {/* {activeTab === 2 && (
            <TaskDispatchView 
              data={taskDispatchData.taskGroupMatrix}
              selectedTasks={selectedTasks}
              selectedGroups={selectedGroups}
              onTaskSelect={handleTaskSelect}
              onGroupSelect={handleGroupSelect}
              onDispatchTasks={handleDispatchTasks}
              onCellClick={handleCellClick}
              getStatusColor={getStatusColor}
              getStatusText={getStatusText}
            />
          )} */}
          
          {activeTab === 2 && (
            <TaskResultsView 
              data={taskDispatchData.taskGroupMatrix}
              getStatusColor={getStatusColor}
              getStatusText={getStatusText}
            />
          )}
        </Box>

        {/* 建立任務對話框 */}
        <CreateTaskDialog 
          open={openCreateTaskDialog}
          onClose={() => setOpenCreateTaskDialog(false)}
          onSuccess={(message) => {
            setSnackbar({ open: true, message, severity: 'success' });
            setOpenCreateTaskDialog(false);
          }}
        />

        {/* 管理任務對話框 */}
        <ManageTaskDialog 
          open={openManageTaskDialog}
          onClose={() => setOpenManageTaskDialog(false)}
          tasks={taskDispatchData.taskGroupMatrix.tasks}
          onSuccess={(message) => {
            setSnackbar({ open: true, message, severity: 'success' });
            setOpenManageTaskDialog(false);
          }}
        />

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert 
            onClose={() => setSnackbar({ ...snackbar, open: false })} 
            severity={snackbar.severity}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

// 任務清單視圖
function TaskListView({ data, courseDispatchId, onCreateTask, onManageTask, onDataChange }) {
  const [tasks, setTasks] = useState(data.tasks);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openAddSubtaskDialog, setOpenAddSubtaskDialog] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [expandedUnits, setExpandedUnits] = useState({}); // 章節展開狀態
  const [targetUnitForSubtask, setTargetUnitForSubtask] = useState(null); // 新增子任務的目標章節
  // 批次派送相關狀態
  const [selectedTaskIds, setSelectedTaskIds] = useState([]); // 被勾選的任務 ID
  const [isBatchDialogOpen, setIsBatchDialogOpen] = useState(false);
  const [batchMode, setBatchMode] = useState('immediate'); // 'immediate' | 'scheduled'
  const [batchSelectedGroupIds, setBatchSelectedGroupIds] = useState([]); // 被選擇的小組 ID
  const [batchScheduledAt, setBatchScheduledAt] = useState('');
  const [isSubmittingBatch, setIsSubmittingBatch] = useState(false);

  // 任務標籤選項（順序與 WallDrawer.js 側欄一致：想法、提問、資訊、實驗、紀錄）
  const tagOptions = [
    { value: '想法', label: '想法', color: '#FFF9C4' },
    { value: '提問', label: '提問', color: '#BBDEFB' },
    { value: '資訊', label: '資訊', color: '#C8E6C9' },
    { value: '實驗', label: '實驗', color: '#FFCDD2' },
    { value: '紀錄', label: '紀錄', color: '#B2EBF2' }
  ];

  const getTagInfo = (tag) => {
    return tagOptions.find(option => option.value === tag) || tagOptions[0];
  };

  // 將中文標籤映射為後端 task_type
  const getBackendTaskType = (tag) => {
    const mapping = {
      '想法': 'idea',
      '提問': 'question',
      '資訊': 'info',
      '紀錄': 'record',
      '實驗': 'experiment'
    };
    return mapping[tag] || 'idea';
  };

  // 同步 tasks 狀態與 data 變化
  useEffect(() => {
    setTasks(data.tasks);
  }, [data.tasks]);

  // 取得小組列表（用於批次派送）
  const groups = data.groups || [];

  // 勾選 / 取消勾選單一任務
  const toggleTaskSelection = (taskId, checked) => {
    setSelectedTaskIds((prev) => {
      if (checked) {
        if (prev.includes(taskId)) return prev;
        return [...prev, taskId];
      } else {
        return prev.filter((id) => id !== taskId);
      }
    });
  };

  // 全選 / 全不選所有任務
  const handleToggleSelectAllTasks = () => {
    if (selectedTaskIds.length === tasks.length) {
      setSelectedTaskIds([]);
    } else {
      setSelectedTaskIds(tasks.map((t) => t.id));
    }
  };

  // 切換小組選擇
  const toggleGroupSelection = (groupId) => {
    setBatchSelectedGroupIds((prev) => {
      if (prev.includes(groupId)) {
        return prev.filter((id) => id !== groupId);
      }
      return [...prev, groupId];
    });
  };

  const handleToggleSelectAllGroups = () => {
    if (batchSelectedGroupIds.length === groups.length) {
      setBatchSelectedGroupIds([]);
    } else {
      setBatchSelectedGroupIds(groups.map((g) => g.id));
    }
  };

  // 保存任務順序到後端
  const saveTaskOrder = async (newTasks) => {
    try {
      const taskOrders = newTasks.map((task, index) => ({
        task_id: task.id,
        order_index: index
      }));

      const response = await axiosInstance.put(
        `${config.reorderApplicationTasks}${courseDispatchId}/reorder`,
        { task_orders: taskOrders }
      );

      if (response.data.success) {
        setSnackbar({ open: true, message: '任務順序已保存', severity: 'success' });
        // 刷新數據以確保同步
        if (onDataChange) {
          await onDataChange();
        }
      } else {
        throw new Error(response.data.message || '保存失敗');
      }
    } catch (error) {
      console.error('保存任務順序失敗:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '保存任務順序失敗', 
        severity: 'error' 
      });
    }
  };

  // 使用箭頭按鈕調整任務順序（與備課包相同邏輯：只交換兩個任務的 unit_number 和 subtask_number）
  const handleMoveTask = async (taskId, direction) => {
    try {
      // 按照 unit_number 和 subtask_number 排序任務列表（用於確定移動位置）
      const sortedTasks = [...tasks].sort((a, b) => {
        let aUnit = a.unit_number;
        let bUnit = b.unit_number;
        let aSubtask = a.subtask_number;
        let bSubtask = b.subtask_number;
        
        // 如果直接屬性沒有，從 customizations 取得
        if ((aUnit === null || aUnit === undefined) && a.customizations) {
          const customizations = typeof a.customizations === 'string' ? JSON.parse(a.customizations) : a.customizations;
          aUnit = customizations?.unit_number;
          aSubtask = customizations?.subtask_number;
    }
        if ((bUnit === null || bUnit === undefined) && b.customizations) {
          const customizations = typeof b.customizations === 'string' ? JSON.parse(b.customizations) : b.customizations;
          bUnit = customizations?.unit_number;
          bSubtask = customizations?.subtask_number;
        }
        
        // 如果還是沒有，根據 order_index 自動生成
        if ((aUnit === null || aUnit === undefined) && a.order_index !== null && a.order_index !== undefined) {
          const orderIndex = parseInt(a.order_index) || 0;
          aUnit = Math.floor(orderIndex / 10000) + 1;
          aSubtask = orderIndex % 10000 || 1;
        }
        if ((bUnit === null || bUnit === undefined) && b.order_index !== null && b.order_index !== undefined) {
          const orderIndex = parseInt(b.order_index) || 0;
          bUnit = Math.floor(orderIndex / 10000) + 1;
          bSubtask = orderIndex % 10000 || 1;
    }

        // 預設值
        aUnit = aUnit ?? 1;
        bUnit = bUnit ?? 1;
        aSubtask = typeof aSubtask === 'number' ? aSubtask : (aSubtask ? parseInt(aSubtask) : 1);
        bSubtask = typeof bSubtask === 'number' ? bSubtask : (bSubtask ? parseInt(bSubtask) : 1);
        
        if (aUnit !== bUnit) {
          return aUnit - bUnit;
        }
        return aSubtask - bSubtask;
      });
      
      const taskIndex = sortedTasks.findIndex(task => task.id === taskId);
      
      if (taskIndex === -1) {
        alert('找不到要移動的任務');
        return;
      }

      const newIndex = direction === 'up' ? taskIndex - 1 : taskIndex + 1;
      
      if (newIndex < 0 || newIndex >= sortedTasks.length) {
        return; // 已經到達邊界
      }

      // 只交換兩個任務的 unit_number 和 subtask_number
      const task1 = sortedTasks[taskIndex];
      const task2 = sortedTasks[newIndex];
      
      // 調用後端API交換順序（後端會交換兩個任務的 unit_number 和 subtask_number）
      const response = await axiosInstance.put(
        `${config.reorderApplicationTasks}${courseDispatchId}/reorder`,
        { 
          task_orders: [
            { task_id: task1.id, order_index: 0 },
            { task_id: task2.id, order_index: 1 }
          ]
        }
      );

      if (response.data.success) {
        setSnackbar({ open: true, message: '任務順序已調整', severity: 'success' });
        // 刷新數據
        if (onDataChange) {
          await onDataChange();
        }
      }
    } catch (error) {
      console.error('調整任務順序錯誤:', error);
      setSnackbar({ 
        open: true, 
        message: '調整任務順序失敗', 
        severity: 'error' 
      });
    }
  };

  const handleEditTask = (task) => {
    // 確保正確映射後端字段到前端狀態
    // 後端已經將 is_optional 轉換為 requiresSubmission，優先使用 requiresSubmission
    // 如果不存在，再根據 is_optional 判斷（兼容舊數據）
    const requiresSubmission = task.requiresSubmission !== undefined 
      ? task.requiresSubmission 
      : (task.is_optional !== undefined ? !task.is_optional : false);
    
    setEditingTask({ 
      ...task,
      useBrainstormWall: task.use_brainstorm_wall || false,
      requiresSubmission: requiresSubmission
    });
    setOpenEditDialog(true);
  };

  // 用於防止重複點擊的 ref
  const isSubmittingRef = React.useRef(false);

  const handleSaveTask = async () => {
    if (!editingTask) return;

    // 前端驗證
    if (!editingTask.title || editingTask.title.trim() === '') {
      setSnackbar({ open: true, message: '請輸入任務標題', severity: 'error' });
      return;
    }

    // 防重複點擊：如果正在提交，直接返回
    if (isSubmittingRef.current) {
      console.log('[handleSaveTask] 正在提交中，忽略重複點擊');
      return;
    }

    try {
      isSubmittingRef.current = true;
      if (editingTask.id && editingTask.id !== null && tasks.find(t => t.id === editingTask.id)) {
        // 更新現有任務
        const response = await axiosInstance.put(`${config.updateApplicationTask}${editingTask.id}`, {
          title: editingTask.title,
          task_content: editingTask.description,
          task_type: getBackendTaskType(editingTask.tag),
          use_brainstorm_wall: editingTask.useBrainstormWall || false,
          is_optional: !editingTask.requiresSubmission
        });

        if (response.data.success) {
          setSnackbar({ open: true, message: '任務更新成功', severity: 'success' });
          // 刷新數據
          if (onDataChange) {
            await onDataChange();
          }
        } else {
          throw new Error(response.data.message || '更新失敗');
        }
      } else {
        // 創建新任務 - 根據類型計算章節/子任務編號
        let newUnitNumber = 1;
        let newSubtaskNumber = 1;
        
        if (editingTask.type === 'subtask' && editingTask.targetUnitNumber !== null && editingTask.targetUnitNumber !== undefined) {
          // 新增子任務：使用指定的章節號
          newUnitNumber = editingTask.targetUnitNumber;
          const sameUnitTasks = tasks.filter(t => {
            let unitNum = t.unit_number;
            if (!unitNum && t.customizations) {
              const customizations = typeof t.customizations === 'string' ? JSON.parse(t.customizations) : t.customizations;
              unitNum = customizations?.unit_number;
            }
            if (!unitNum && t.order_index !== null && t.order_index !== undefined) {
              const orderIndex = parseInt(t.order_index) || 0;
              unitNum = Math.floor(orderIndex / 10000) + 1;
            }
            return unitNum === newUnitNumber;
          });
          
          if (sameUnitTasks.length > 0) {
            const maxSubtask = Math.max(
              ...sameUnitTasks.map(t => {
                let subtaskNum = t.subtask_number;
                if (!subtaskNum && t.customizations) {
                  const customizations = typeof t.customizations === 'string' ? JSON.parse(t.customizations) : t.customizations;
                  subtaskNum = customizations?.subtask_number;
                }
                if (!subtaskNum && t.order_index !== null && t.order_index !== undefined) {
                  const orderIndex = parseInt(t.order_index) || 0;
                  subtaskNum = orderIndex % 10000 || 1;
                }
                const num = typeof subtaskNum === 'number' ? subtaskNum : (subtaskNum ? parseInt(subtaskNum) : 1);
                return num;
              }),
              0
            );
            newSubtaskNumber = maxSubtask + 1;
          } else {
            newSubtaskNumber = 1;
          }
        } else {
          // 新增章節或一般任務：計算最大章節號 + 1
          if (tasks.length > 0) {
            const maxUnit = Math.max(
              ...tasks.map(t => {
                let unitNum = t.unit_number;
                if (!unitNum && t.customizations) {
                  const customizations = typeof t.customizations === 'string' ? JSON.parse(t.customizations) : t.customizations;
                  unitNum = customizations?.unit_number;
                }
                if (!unitNum && t.order_index !== null && t.order_index !== undefined) {
                  const orderIndex = parseInt(t.order_index) || 0;
                  unitNum = Math.floor(orderIndex / 10000) + 1;
                }
                return unitNum || 0;
              }),
              0
            );
            newUnitNumber = maxUnit > 0 ? maxUnit + 1 : 1;
            newSubtaskNumber = 1;
          }
        }
        
        const response = await axiosInstance.post(config.createApplicationTask, {
          course_dispatch_id: courseDispatchId,
          title: editingTask.title,
          task_content: editingTask.description,
          task_type: getBackendTaskType(editingTask.tag),
          use_brainstorm_wall: editingTask.useBrainstormWall || false,
          is_customized: true,
          is_optional: !editingTask.requiresSubmission,
          unit_number: newUnitNumber,
          subtask_number: newSubtaskNumber
        });

        if (response.data.success) {
          setSnackbar({ open: true, message: '任務創建成功', severity: 'success' });
          // 刷新數據
          if (onDataChange) {
            await onDataChange();
          }
        } else {
          throw new Error(response.data.message || '創建失敗');
        }
      }
      
      if (editingTask?.type === 'subtask') {
        setOpenAddSubtaskDialog(false);
      } else {
      setOpenEditDialog(false);
      }
      setEditingTask(null);
      setTargetUnitForSubtask(null);
    } catch (error) {
      console.error('保存任務失敗:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '保存任務失敗', 
        severity: 'error' 
      });
    } finally {
      // 延遲清除標記，避免快速重複點擊
      setTimeout(() => {
        isSubmittingRef.current = false;
      }, 1000);
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!window.confirm('確定要刪除這個任務嗎？')) {
      return;
    }

    try {
      const response = await axiosInstance.delete(`${config.deleteApplicationTask}${taskId}`);
      
      if (response.data.success) {
        setSnackbar({ open: true, message: '任務刪除成功', severity: 'success' });
        // 刷新數據
        if (onDataChange) {
          await onDataChange();
        }
      } else {
        throw new Error(response.data.message || '刪除失敗');
      }
    } catch (error) {
      console.error('刪除任務失敗:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '刪除任務失敗', 
        severity: 'error' 
      });
    }
  };

  // 新增章節 - 直接建立空任務並打開編輯視窗
  const handleAddUnit = async () => {
    try {
      // 計算新的章節號
      let newUnitNumber = 1;
      if (tasks.length > 0) {
        const maxUnit = Math.max(
          ...tasks.map(t => {
            let unitNum = t.unit_number;
            if (!unitNum && t.customizations) {
              const customizations = typeof t.customizations === 'string' ? JSON.parse(t.customizations) : t.customizations;
              unitNum = customizations?.unit_number;
            }
            if (!unitNum && t.order_index !== null && t.order_index !== undefined) {
              const orderIndex = parseInt(t.order_index) || 0;
              unitNum = Math.floor(orderIndex / 10000) + 1;
            }
            return unitNum || 0;
          }),
          0
        );
        newUnitNumber = maxUnit > 0 ? maxUnit + 1 : 1;
      }
      
      const response = await axiosInstance.post(config.createApplicationTask, {
        course_dispatch_id: courseDispatchId,
        title: '新任務',
        task_content: '',
        task_type: 'idea',
        use_brainstorm_wall: false,
        is_optional: false,
        unit_number: newUnitNumber,
        subtask_number: 1
      });
      
      if (response.data.success) {
        const newTaskId = response.data.data?.id || response.data.data?.task?.id;
        const newTaskData = response.data.data?.task || response.data.data;
        
        // 如果 API 返回了完整的任務數據，直接使用
        if (newTaskData && newTaskData.id) {
          // 構建任務對象以匹配前端格式
          const taskToEdit = {
            id: newTaskData.id,
            title: newTaskData.title || '新任務',
            description: newTaskData.task_content || newTaskData.description || '',
            tag: newTaskData.task_type ? 
              (newTaskData.task_type === 'idea' ? '想法' :
               newTaskData.task_type === 'question' ? '提問' :
               newTaskData.task_type === 'info' ? '資訊' :
               newTaskData.task_type === 'record' ? '紀錄' :
               newTaskData.task_type === 'experiment' ? '實驗' : '想法') : '想法',
            use_brainstorm_wall: newTaskData.use_brainstorm_wall || false,
            requiresSubmission: !newTaskData.is_optional,
            unit_number: newTaskData.unit_number || newUnitNumber,
            subtask_number: newTaskData.subtask_number || 1
          };
          
          // 直接打開編輯視窗
          setEditingTask(taskToEdit);
          setOpenEditDialog(true);
        } else {
          // 如果 API 沒有返回完整數據，刷新數據後再查找
          if (onDataChange) {
            await onDataChange();
          }
          
          // 等待數據更新後，找到新創建的任務並打開編輯視窗
          setTimeout(() => {
            // 從更新後的 data.tasks 中找到新任務
            const findNewTask = () => {
              const currentTasks = data.tasks || [];
              let newTask = null;
              
              if (newTaskId) {
                // 如果有任務ID，直接使用ID查找
                newTask = currentTasks.find(t => t.id === newTaskId);
              }
              
              // 如果找不到，嘗試根據 unit_number 和 title 查找
              if (!newTask) {
                newTask = currentTasks.find(t => {
                  let unitNum = t.unit_number;
                  if (!unitNum && t.customizations) {
                    const customizations = typeof t.customizations === 'string' ? JSON.parse(t.customizations) : t.customizations;
                    unitNum = customizations?.unit_number;
                  }
                  return unitNum === newUnitNumber && (t.title === '新任務' || !t.title);
                });
              }
              
              return newTask;
            };
            
            // 嘗試多次查找，因為狀態更新可能需要時間
            let attempts = 0;
            const maxAttempts = 5;
            const checkInterval = setInterval(() => {
              attempts++;
              const newTask = findNewTask();
              if (newTask) {
                clearInterval(checkInterval);
                // 設置編輯任務並打開編輯視窗
                handleEditTask(newTask);
              } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.warn('無法找到新創建的任務，請手動編輯');
              }
            }, 200);
          }, 300);
        }
        
        setSnackbar({ open: true, message: '章節已建立', severity: 'success' });
      }
    } catch (error) {
      console.error('建立章節錯誤:', error);
      setSnackbar({ 
        open: true, 
        message: error.response?.data?.message || '建立章節失敗', 
        severity: 'error' 
      });
    }
  };

  // 新增子任務
  const handleAddSubtask = (targetUnitNumber) => {
    setTargetUnitForSubtask(targetUnitNumber);
    const newTask = {
      id: null,
      type: 'subtask',
      targetUnitNumber: targetUnitNumber,
      title: '',
      description: '',
      tag: '想法',
      requiresSubmission: false
    };
    setEditingTask(newTask);
    setOpenAddSubtaskDialog(true);
  };

  const handleCreateTask = () => {
    const newTask = {
      id: null, // 新任務將由後端生成 ID
      title: '',
      description: '',
      tag: '想法',
      requiresSubmission: false
    };
    setEditingTask(newTask);
    setOpenEditDialog(true);
  };

  // 按章節分組任務
  const groupTasksByUnit = () => {
    const grouped = {};
    
    tasks.forEach(task => {
      // 從 customizations 或直接屬性取得章節/子任務
      let unitNumber = task.unit_number;
      let subtaskNumber = task.subtask_number;
      
      // 如果直接屬性沒有，從 customizations 取得
      if ((unitNumber === null || unitNumber === undefined) && task.customizations) {
        const customizations = typeof task.customizations === 'string' ? JSON.parse(task.customizations) : task.customizations;
        unitNumber = customizations?.unit_number;
        subtaskNumber = customizations?.subtask_number;
      }
      
      // 如果還是沒有，根據 order_index 自動生成
      if ((unitNumber === null || unitNumber === undefined) && task.order_index !== null && task.order_index !== undefined) {
        const orderIndex = parseInt(task.order_index) || 0;
        unitNumber = Math.floor(orderIndex / 10000) + 1;
        subtaskNumber = orderIndex % 10000 || 1;
      }
      
      // 預設值
      unitNumber = unitNumber ?? 1;
      subtaskNumber = typeof subtaskNumber === 'number' ? subtaskNumber : (subtaskNumber ? parseInt(subtaskNumber) : 1);
      
      const unitKey = `unit_${unitNumber}`;
      
      if (!grouped[unitKey]) {
        grouped[unitKey] = {
          unitNumber: unitNumber,
          tasks: []
        };
      }
      
      grouped[unitKey].tasks.push({
        ...task,
        displayUnitNumber: unitNumber,
        displaySubtaskNumber: subtaskNumber
      });
    });
    
    // 對每個章節的任務按 subtask_number 排序
    Object.keys(grouped).forEach(key => {
      grouped[key].tasks.sort((a, b) => {
        const aNum = typeof a.displaySubtaskNumber === 'number' ? a.displaySubtaskNumber : (parseInt(a.displaySubtaskNumber) || 0);
        const bNum = typeof b.displaySubtaskNumber === 'number' ? b.displaySubtaskNumber : (parseInt(b.displaySubtaskNumber) || 0);
        return aNum - bNum;
      });
    });
    
    return grouped;
  };

  const toggleUnit = (unitKey) => {
    setExpandedUnits(prev => ({
      ...prev,
      [unitKey]: !prev[unitKey]
    }));
  };

  const grouped = groupTasksByUnit();
  const unitKeys = Object.keys(grouped).sort((a, b) => {
    return grouped[a].unitNumber - grouped[b].unitNumber;
  });

  return (
    <>
      {/* 簡約風格的任務列表 */}
      <Box sx={{ 
        backgroundColor: '#fff', 
        borderRadius: 2, 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* 標題欄 */}
        <Box sx={{ 
          p: 2, 
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
            任務管理 ({tasks.length})
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
            {tasks.length > 0 && (
              <Button
                variant="outlined"
                size="small"
                onClick={handleToggleSelectAllTasks}
                sx={{
                  textTransform: 'none !important',
                  borderRadius: '8px !important',
                  fontSize: '0.8rem !important',
                  padding: '6px 14px !important',
                  minWidth: 'auto !important',
                  boxShadow: 'none !important',
                  borderColor: '#2b687f !important',
                  color: '#2b687f !important',
                  '&:hover': {
                    backgroundColor: '#e3f2fd !important',
                    borderColor: '#1e4d5a !important'
                  }
                }}
              >
                {selectedTaskIds.length === tasks.length ? '取消全選任務' : '全選所有任務'}
              </Button>
            )}
            <Button
              variant="outlined"
              size="small"
              disabled={selectedTaskIds.length === 0}
              onClick={() => {
                // 開啟批次對話框時，預設不選任何小組，讓老師明確選擇
                setBatchSelectedGroupIds([]);
                setBatchMode('immediate');
                setBatchScheduledAt('');
                setIsBatchDialogOpen(true);
              }}
              sx={{
                textTransform: 'none !important',
                borderRadius: '8px !important',
                fontSize: '0.8rem !important',
                padding: '6px 14px !important',
                minWidth: 'auto !important',
                boxShadow: 'none !important',
                borderColor: '#2b687f !important',
                color: '#2b687f !important',
                opacity: selectedTaskIds.length === 0 ? 0.4 : 1,
                '&:hover': selectedTaskIds.length === 0 ? {} : {
                  backgroundColor: '#e3f2fd !important', borderColor: '#1e4d5a !important'
                }
              }}
            >
              批次派送 / 排程
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddUnit}
              sx={{
                backgroundColor: '#2b687f !important',
                '&:hover': { backgroundColor: '#1e4d5a !important' },
                textTransform: 'none !important',
                borderRadius: '8px !important',
                fontSize: '0.875rem !important',
                padding: '6px 16px !important',
                minWidth: 'auto !important',
                boxShadow: 'none !important'
              }}
            >
              新增章節
            </Button>
          </Box>
        </Box>

        {/* 任務列表 - 按章節分組顯示 */}
        <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {tasks.length === 0 ? (
            <Box sx={{ p: 4, textAlign: 'center', color: '#666' }}>
              <Typography variant="body1">尚未建立任何任務</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                點擊「新增章節」開始建立第一個任務
              </Typography>
            </Box>
          ) : (
            <List sx={{ p: 0 }}>
              {unitKeys.length > 0 && unitKeys.map(unitKey => {
                const unitData = grouped[unitKey];
                const isExpanded = expandedUnits[unitKey] !== false; // 預設展開
                
                return (
                  <Accordion
                    key={unitKey}
                    expanded={isExpanded}
                    onChange={() => toggleUnit(unitKey)}
                    sx={{
                      mb: 1.5,
                      '&:before': { display: 'none' },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                      borderRadius: 2,
                      overflow: 'hidden'
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: '#e3f2fd',
                        minHeight: 48,
                        '&.Mui-expanded': {
                          minHeight: 48
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>
                          章節 {unitData.unitNumber} ({unitData.tasks.length} 個任務)
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddSubtask(unitData.unitNumber);
                          }}
                          sx={{
                            color: '#1976d2',
                            '&:hover': {
                              backgroundColor: 'rgba(25, 118, 210, 0.1)'
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, bgcolor: '#fafafa' }}>
                      {unitData.tasks.map((task, index) => {
                const tagInfo = getTagInfo(task.tag);
                        
                        // 計算該任務在所有任務中的索引（用於判斷是否可以移動）
                        const sortedAllTasks = [...tasks].sort((a, b) => {
                          let aUnit = a.unit_number;
                          let bUnit = b.unit_number;
                          let aSubtask = a.subtask_number;
                          let bSubtask = b.subtask_number;
                          
                          if ((aUnit === null || aUnit === undefined) && a.customizations) {
                            const customizations = typeof a.customizations === 'string' ? JSON.parse(a.customizations) : a.customizations;
                            aUnit = customizations?.unit_number;
                            aSubtask = customizations?.subtask_number;
                          }
                          if ((bUnit === null || bUnit === undefined) && b.customizations) {
                            const customizations = typeof b.customizations === 'string' ? JSON.parse(b.customizations) : b.customizations;
                            bUnit = customizations?.unit_number;
                            bSubtask = customizations?.subtask_number;
                          }
                          
                          if ((aUnit === null || aUnit === undefined) && a.order_index !== null && a.order_index !== undefined) {
                            const orderIndex = parseInt(a.order_index) || 0;
                            aUnit = Math.floor(orderIndex / 10000) + 1;
                            aSubtask = orderIndex % 10000 || 1;
                          }
                          if ((bUnit === null || bUnit === undefined) && b.order_index !== null && b.order_index !== undefined) {
                            const orderIndex = parseInt(b.order_index) || 0;
                            bUnit = Math.floor(orderIndex / 10000) + 1;
                            bSubtask = orderIndex % 10000 || 1;
                          }
                          
                          aUnit = aUnit ?? 1;
                          bUnit = bUnit ?? 1;
                          aSubtask = typeof aSubtask === 'number' ? aSubtask : (aSubtask ? parseInt(aSubtask) : 1);
                          bSubtask = typeof bSubtask === 'number' ? bSubtask : (bSubtask ? parseInt(bSubtask) : 1);
                          
                          if (aUnit !== bUnit) {
                            return aUnit - bUnit;
                          }
                          return aSubtask - bSubtask;
                        });
                        const globalTaskIndex = sortedAllTasks.findIndex(t => t.id === task.id);
                        const canMoveUp = globalTaskIndex > 0;
                        const canMoveDown = globalTaskIndex < sortedAllTasks.length - 1;
                
                return (
                  <ListItem
                    key={task.id}
                    sx={{
                              mb: 1,
                              p: 2,
                              borderRadius: 1,
                              border: '1px solid',
                              borderColor: '#e0e0e0',
                              backgroundColor: 'white',
                              transition: 'all 0.3s',
                              ml: 1,
                              mr: 1,
                              mt: index === 0 ? 1 : 0,
                              mb: index === unitData.tasks.length - 1 ? 1 : 1,
                              '&:hover': {
                                borderColor: '#2b687f',
                                boxShadow: '0 4px 12px rgba(43,104,127,0.15)',
                                transform: 'translateY(-2px)'
                              }
                            }}
                          >
                            <MuiListItemIcon>
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <Checkbox
                                  edge="start"
                                  size="small"
                                  checked={selectedTaskIds.includes(task.id)}
                                  onChange={(e) => toggleTaskSelection(task.id, e.target.checked)}
                                  inputProps={{ 'aria-label': `選取任務 ${task.title || ''}` }}
                                />
                                <Chip
                                  label={`${task.displayUnitNumber}-${task.displaySubtaskNumber}`}
                                  size="small"
                                  sx={{
                                    backgroundColor: '#e3f2fd',
                                    color: '#1976d2',
                                    fontSize: '0.7rem',
                                    height: 20,
                                    fontWeight: 500
                                  }}
                                />
                              </Box>
                            </MuiListItemIcon>
                    <MuiListItemText
                      primary={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                    {task.title || '未命名任務'}
                                  </Typography>
                          <Chip
                            label={tagInfo.label}
                            size="small"
                            sx={{
                              backgroundColor: tagInfo.color,
                              color: '#333',
                              fontSize: '11px',
                              height: 20
                            }}
                          />
                          {task.requiresSubmission && (
                            <Chip
                              label="需繳交"
                              size="small"
                              sx={{
                                backgroundColor: '#ffebee',
                                color: '#d32f2f',
                                fontSize: '10px',
                                height: 18
                              }}
                            />
                          )}
                                  {task.use_brainstorm_wall && (
                                    <Chip
                                      label="問題牆"
                                      size="small"
                                      color="success"
                                      sx={{ fontSize: '10px', height: 18 }}
                            />
                          )}
                        </Box>
                      }
                      secondary={
                                <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.4, mt: 0.5 }}>
                          {task.description}
                        </Typography>
                      }
                    />
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Tooltip title={canMoveUp ? '上移' : ''}>
                                  <span>
                      <IconButton
                        size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMoveTask(task.id, 'up');
                                      }}
                                      disabled={!canMoveUp}
                                      sx={{ p: 0.25 }}
                                    >
                                      <ArrowUpIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Tooltip title={canMoveDown ? '下移' : ''}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMoveTask(task.id, 'down');
                                      }}
                                      disabled={!canMoveDown}
                                      sx={{ p: 0.25 }}
                                    >
                                      <ArrowDownIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </Box>
                              <Tooltip title="編輯任務">
                                <IconButton
                                  size="small"
                                  onClick={() => handleEditTask(task)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                              </Tooltip>
                              <Tooltip title="刪除任務">
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteTask(task.id)}
                                  sx={{ color: 'error.main' }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                              </Tooltip>
                    </Box>
                  </ListItem>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </List>
          )}
        </Box>
      </Box>

      {/* 任務編輯對話框 */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            zIndex: 1300
          },
          '& .MuiBackdrop-root': {
            zIndex: 1299
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <EditIcon sx={{ color: '#2b687f', fontSize: '1.25rem' }} />
            <Typography variant="h6">
              {editingTask?.id && tasks.find(t => t.id === editingTask.id) ? '編輯任務' : '新增任務'}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {editingTask && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label="任務標題"
                value={editingTask.title}
                onChange={(e) => {
                  const value = e.target.value || '';
                  if (value.length <= 15) {
                    setEditingTask({ ...editingTask, title: value });
                  }
                }}
                fullWidth
                required
                helperText={`${Math.min((editingTask.title || '').length, 15)}/15 字`}
                inputProps={{ maxLength: 15 }}
              />
              <TextField
                label="任務描述"
                value={editingTask.description}
                onChange={(e) => setEditingTask({ ...editingTask, description: e.target.value })}
                multiline
                rows={3}
                fullWidth
              />
              <FormControl fullWidth>
                <InputLabel>任務標籤</InputLabel>
                <Select
                  value={editingTask.tag}
                  onChange={(e) => setEditingTask({ ...editingTask, tag: e.target.value })}
                  label="任務標籤"
                  MenuProps={{
                    style: {
                      zIndex: 999999999
                    },
                    PaperProps: {
                      style: {
                        zIndex: 999999999
                      }
                    },
                    disableScrollLock: true,
                    disablePortal: false
                  }}
                >
                  {tagOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box 
                          sx={{ 
                            width: 12, 
                            height: 12, 
                            backgroundColor: option.color,
                            borderRadius: '2px'
                          }} 
                        />
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControlLabel
                control={
                  <Switch
                    checked={editingTask.requiresSubmission}
                    onChange={(e) => setEditingTask({ ...editingTask, requiresSubmission: e.target.checked })}
                  />
                }
                label="需要繳交成果"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={editingTask.useBrainstormWall || false}
                    onChange={(e) => setEditingTask({ ...editingTask, useBrainstormWall: e.target.checked })}
                  />
                }
                label="使用問題牆"
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setOpenEditDialog(false)}>
            取消
          </Button>
          <Button onClick={handleSaveTask} variant="contained">
            儲存
          </Button>
        </DialogActions>
      </Dialog>

      {/* 批次派送 / 排程對話框 */}
      <Dialog
        open={isBatchDialogOpen}
        onClose={() => {
          if (!isSubmittingBatch) setIsBatchDialogOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>批次派送 / 排程任務</DialogTitle>
        <DialogContent dividers>
          {/* 已選任務摘要 */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
              已選擇的任務（{selectedTaskIds.length} 個）
            </Typography>
            <List dense>
              {tasks
                .filter((t) => selectedTaskIds.includes(t.id))
                .map((task) => {
                  const displayUnit = task.unit_number ?? task.displayUnitNumber ?? '';
                  const displaySubtask = task.subtask_number ?? task.displaySubtaskNumber ?? '';
                  return (
                    <ListItem key={task.id} sx={{ py: 0.5 }}>
                      <ListItemIcon>
                        <Chip
                          label={`${displayUnit || '?'}-${displaySubtask || '?'}`}
                          size="small"
                          sx={{
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                            fontSize: '0.7rem',
                            height: 20
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {task.title || '未命名任務'}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
            </List>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* 小組選擇 */}
          <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                選擇派送小組
              </Typography>
              {groups.length > 0 && (
                <Button
                  size="small"
                  variant="text"
                  onClick={handleToggleSelectAllGroups}
                  sx={{ textTransform: 'none', fontSize: '0.8rem' }}
                >
                  {batchSelectedGroupIds.length === groups.length ? '取消全選小組' : '全選所有小組'}
                </Button>
              )}
            </Box>
            {groups.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                尚未建立任何小組。
              </Typography>
            ) : (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {groups.map((group) => (
                  <Chip
                    key={group.id}
                    label={group.groupName || group.name || `小組 ${group.id}`}
                    clickable
                    onClick={() => toggleGroupSelection(group.id)}
                    color={batchSelectedGroupIds.includes(group.id) ? 'primary' : 'default'}
                    variant={batchSelectedGroupIds.includes(group.id) ? 'filled' : 'outlined'}
                    sx={{ fontSize: '0.8rem' }}
                  />
                ))}
              </Box>
            )}
            {batchSelectedGroupIds.length === 0 && (
              <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
                請至少選擇一個小組。
              </Typography>
            )}
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* 模式選擇：立即派送 / 排程（排程＝任務狀態設為「排程」，暫不派發到學生牆） */}
          <Box sx={{ mb: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
              派送方式
            </Typography>
            <ToggleButtonGroup
              value={batchMode}
              exclusive
              onChange={(e, value) => {
                if (value !== null) setBatchMode(value);
              }}
              size="small"
              sx={{ mb: 1 }}
            >
              <ToggleButton value="immediate">立即派送</ToggleButton>
              <ToggleButton value="scheduled">排程派送</ToggleButton>
            </ToggleButtonGroup>

            {batchMode === 'scheduled' && (
              <Box sx={{ mt: 1 }}>
                <Alert severity="info" sx={{ p: 1.5 }}>
                  <Typography variant="body2">
                    排程派送會將這些任務的狀態設為「排程」，暫時不出現在學生的想法牆 / 問題牆。
                    之後再從矩陣中將狀態改為「已派發」，才會真的送到學生端。
                  </Typography>
                </Alert>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (!isSubmittingBatch) setIsBatchDialogOpen(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="contained"
            disabled={
              isSubmittingBatch ||
              selectedTaskIds.length === 0 ||
              batchSelectedGroupIds.length === 0
            }
            onClick={async () => {
              try {
                setIsSubmittingBatch(true);

                const payload = {
                  task_ids: selectedTaskIds,
                  group_ids: batchSelectedGroupIds,
                  mode: batchMode,
                  // 目前的「排程派送」表示任務狀態進入「排程」，不需要具體時間
                  scheduled_at: null
                };

                console.log('📤 [BatchDispatch] 準備批次派送 / 排程:', payload);

                // TODO: 實作後端 API：POST /api/application-tasks/course-dispatch/:courseDispatchId/batch-dispatch
                // 這裡先呼叫預留路由，若尚未實作則只顯示錯誤提示
                const response = await axiosInstance.post(
                  `/api/application-tasks/course-dispatch/${courseDispatchId}/batch-dispatch`,
                  payload
                );

                if (response.data?.success) {
                  setSnackbar({
                    open: true,
                    message:
                      batchMode === 'immediate'
                        ? `已立即派送 ${selectedTaskIds.length} 個任務給 ${batchSelectedGroupIds.length} 個小組`
                        : `已排程 ${selectedTaskIds.length} 個任務給 ${batchSelectedGroupIds.length} 個小組`,
                    severity: 'success'
                  });
                  setIsBatchDialogOpen(false);
                  setSelectedTaskIds([]);
                  if (onDataChange) {
                    await onDataChange();
                  }
                } else {
                  throw new Error(response.data?.message || '批次派送失敗');
                }
              } catch (error) {
                console.error('[BatchDispatch] 批次派送錯誤:', error);
                setSnackbar({
                  open: true,
                  message:
                    error.response?.data?.message ||
                    '批次派送 / 排程失敗，請確認後端 API 是否已實作。',
                  severity: 'error'
                });
              } finally {
                setIsSubmittingBatch(false);
              }
            }}
          >
            {batchMode === 'immediate' ? '立即派送' : '建立排程'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 新增子任務對話框 */}
      <Dialog 
        open={openAddSubtaskDialog} 
        onClose={() => {
          setOpenAddSubtaskDialog(false);
          setEditingTask(null);
          setTargetUnitForSubtask(null);
        }}
        maxWidth="md"
        fullWidth
            sx={{ 
          '& .MuiDialog-paper': {
            zIndex: 1300
          },
          '& .MuiBackdrop-root': {
            zIndex: 1299
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AddIcon sx={{ color: '#2b687f', fontSize: '1.25rem' }} />
            <Typography variant="h6">
              新增子任務
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {editingTask && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label="任務標題"
                value={editingTask.title || ''}
                onChange={(e) => {
                  const value = e.target.value || '';
                  if (value.length <= 15) {
                    setEditingTask({ ...editingTask, title: value });
                  }
                }}
                fullWidth
                required
                helperText={`${Math.min((editingTask.title || '').length, 15)}/15 字`}
                inputProps={{ maxLength: 15 }}
              />
              <TextField
                label="任務描述"
                value={editingTask.description || ''}
                onChange={(e) => setEditingTask({ ...editingTask, description: e.target.value })}
                multiline
                rows={3}
                fullWidth
              />
              <FormControl fullWidth>
                <InputLabel>任務標籤</InputLabel>
                <Select
                  value={editingTask.tag || '想法'}
                  onChange={(e) => setEditingTask({ ...editingTask, tag: e.target.value })}
                  label="任務標籤"
                  MenuProps={{
                    style: {
                      zIndex: 999999999
                    },
                    PaperProps: {
                      style: {
                        zIndex: 999999999
                      }
                    },
                    disableScrollLock: true,
                    disablePortal: false
                  }}
                >
                  {tagOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box 
                          sx={{ 
                            width: 12, 
                            height: 12, 
                            backgroundColor: option.color,
                            borderRadius: '2px'
                          }} 
                        />
                        {option.label}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControlLabel
                control={
                  <Switch
                    checked={editingTask.requiresSubmission || false}
                    onChange={(e) => setEditingTask({ ...editingTask, requiresSubmission: e.target.checked })}
                  />
                }
                label="需要繳交成果"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={editingTask.useBrainstormWall || false}
                    onChange={(e) => setEditingTask({ ...editingTask, useBrainstormWall: e.target.checked })}
                  />
                }
                label="使用問題牆"
              />
              {targetUnitForSubtask && (
                <Box sx={{ 
                  p: 1.5, 
                  bgcolor: 'grey.50', 
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <Typography variant="body2" color="text.secondary">
                    將新增到章節 <strong>{targetUnitForSubtask}</strong>
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => {
            setOpenAddSubtaskDialog(false);
            setEditingTask(null);
            setTargetUnitForSubtask(null);
          }}>
            取消
          </Button>
          <Button onClick={handleSaveTask} variant="contained">
            儲存
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for drag operation feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

// 任務指派視圖
function TaskDispatchView({ 
  data, 
  selectedTasks, 
  selectedGroups, 
  onTaskSelect, 
  onGroupSelect, 
  onDispatchTasks, 
  onCellClick, 
  getStatusColor, 
  getStatusText 
}) {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showStatusConfirmDialog, setShowStatusConfirmDialog] = useState(false);
  const [statusChangeData, setStatusChangeData] = useState(null);

  const handleConfirmDispatch = () => {
    onDispatchTasks();
    setShowConfirmDialog(false);
  };

  const handleCellClickWithConfirm = (taskId, groupId) => {
    const key = `${taskId}_${groupId}`;
    const currentStatus = data.matrixStatus[key]?.status || 'not_dispatched';
    
    // 如果是排程狀態，直接派發任務
    if (currentStatus === 'not_dispatched') {
      onCellClick(taskId, groupId, 'dispatched');
      return;
    }
    
    setStatusChangeData({ taskId, groupId, currentStatus });
    setShowStatusConfirmDialog(true);
  };

  const handleConfirmStatusChange = () => {
    if (statusChangeData && statusChangeData.newStatus) {
      onCellClick(statusChangeData.taskId, statusChangeData.groupId, statusChangeData.newStatus);
      setShowStatusConfirmDialog(false);
      setStatusChangeData(null);
    }
  };

  return (
    <Box>
      {/* 操作按鈕區域 */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6">指派任務</Typography>
        
        {selectedTasks.length > 0 && selectedGroups.length > 0 && (
          <Button
            variant="contained"
            sx={{ 
              backgroundColor: '#2b687f !important', 
              '&:hover': { backgroundColor: '#1e4d5a !important' },
              fontSize: '0.875rem !important',
              padding: '6px 16px !important',
              textTransform: 'none !important',
              borderRadius: '8px !important',
              boxShadow: 'none !important'
            }}
            onClick={() => setShowConfirmDialog(true)}
          >
            確定指派({selectedTasks.length}任務→{selectedGroups.length}小組)
          </Button>
        )}
      </Box>

      {/* 操作說明 - 暫時註解 */}
      {/* <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          <strong>操作說明：</strong>
          <br />• 勾選任務和小組後，點擊「確定指派」即可發送任務
          <br />• 點擊格子可修改該任務在小組中的狀態（需要確認）
          <br />• 狀態會根據小組進度變化，不是任務本身的狀態
        </Typography>
      </Alert> */}

      {/* 狀態圖例 - 暫時註解 */}
      {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 3, justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#f5f5f5', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">排程</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#e3f2fd', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">已派發</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#fff3e0', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">進行中</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#e8f5e8', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">已完成</Typography>
        </Box>
      </Box> */}

      {/* 矩陣表格 */}
      <Card>
        <CardContent sx={{ p: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: 200, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="subtitle2" fontWeight="bold">組別</Typography>
                  </TableCell>
                  {data.tasks.map((task) => (
                    <TableCell key={task.id} sx={{ minWidth: 150, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={selectedTasks.includes(task.id)}
                          onChange={() => onTaskSelect(task.id)}
                          size="small"
                        />
                        {(() => {
                          // 優先使用直接屬性，若無則從 customizations 取得章節/子任務
                          const unitNumber = task.unit_number ?? task.customizations?.unit_number ?? 1;
                          const subtaskNumber = task.subtask_number ?? task.customizations?.subtask_number ?? '1';
                          return (
                            <Chip
                              label={`${unitNumber}-${subtaskNumber}`}
                              size="small"
                              sx={{
                                backgroundColor: '#e3f2fd',
                                color: '#1976d2',
                                fontSize: '9px',
                                height: 18,
                                fontWeight: 500
                              }}
                            />
                          );
                        })()}
                        <Typography variant="subtitle2" fontWeight="bold">
                          {task.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {task.subtitle}
                        </Typography>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* 小組行 */}
                {[...data.groups].sort((a, b) => {
                  // 按組別ID排序（確保組別順序一致）
                  const idA = parseInt(a.id) || 0;
                  const idB = parseInt(b.id) || 0;
                  if (idA !== idB) return idA - idB;
                  // 如果ID相同，按名稱排序
                  const nameA = a.name || a.groupName || '';
                  const nameB = b.name || b.groupName || '';
                  return nameA.localeCompare(nameB, 'zh-TW');
                }).map((group) => (
                  <TableRow key={group.id}>
                    <TableCell sx={{ backgroundColor: '#f8f9fa' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={selectedGroups.includes(group.id)}
                          onChange={() => onGroupSelect(group.id)}
                          size="small"
                        />
                        <Typography variant="subtitle2" fontWeight="bold">
                          {group.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    {data.tasks.map((task) => {
                      const key = `${task.id}_${group.id}`;
                      const cellData = data.matrixStatus[key];
                      const status = cellData?.status || 'not_dispatched';
                      const progress = cellData?.progress;
                      
                      return (
                        <TableCell 
                          key={key} 
                          sx={{ 
                            textAlign: 'center', 
                            backgroundColor: getStatusColor(status),
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: status === 'not_dispatched' ? '#e0e0e0' : getStatusColor(status),
                              opacity: 0.8
                            }
                          }}
                          onClick={() => handleCellClickWithConfirm(task.id, group.id)}
                        >
                          {status === 'not_dispatched' ? (
                            <AddIcon sx={{ color: '#999', fontSize: 20 }} />
                          ) : (
                            <Box>
                              {progress && (
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    fontWeight: 'bold',
                                    color: status === 'in_progress' ? '#ff9800' : 
                                           status === 'completed' ? '#4caf50' : '#666'
                                  }}
                                >
                                  {progress}
                                </Typography>
                              )}
                              <Typography variant="caption" display="block" color="text.secondary">
                                {getStatusText(status)}
                              </Typography>
                            </Box>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* 確認指派對話框 */}
      <Dialog open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)}>
        <DialogTitle>確認指派</DialogTitle>
        <DialogContent>
          <Typography>
            確定要指派 {selectedTasks.length} 個任務到 {selectedGroups.length} 個小組嗎？
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setShowConfirmDialog(false)}>取消</Button>
          <Button onClick={handleConfirmDispatch} variant="contained">
            確定指派
          </Button>
        </DialogActions>
      </Dialog>

      {/* 狀態修改確認對話框 */}
      <Dialog 
        open={showStatusConfirmDialog} 
        onClose={() => setShowStatusConfirmDialog(false)}
        sx={{
          '& .MuiDialog-paper': {
            zIndex: 1300
          },
          '& .MuiBackdrop-root': {
            zIndex: 1299
          }
        }}
      >
        <DialogTitle>修改任務狀態</DialogTitle>
        <DialogContent>
          {statusChangeData && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <Typography variant="body1">
                任務：「{data.tasks.find(t => t.id === statusChangeData.taskId)?.title}」
              </Typography>
              <Typography variant="body1">
                小組：「{data.groups.find(g => g.id === statusChangeData.groupId)?.name}」
              </Typography>
              <Typography variant="body1">
                目前狀態：「{getStatusText(statusChangeData.currentStatus)}」
              </Typography>
              <FormControl fullWidth>
                <InputLabel>選擇新狀態</InputLabel>
                <Select
                  value={statusChangeData.newStatus || statusChangeData.currentStatus}
                  onChange={(e) => setStatusChangeData({ ...statusChangeData, newStatus: e.target.value })}
                  label="選擇新狀態"
                  MenuProps={{
                    style: {
                      zIndex: 999999999
                    },
                    PaperProps: {
                      style: {
                        zIndex: 999999999
                      }
                    },
                    disableScrollLock: true,
                    disablePortal: false
                  }}
                >
                  <MenuItem value="not_dispatched">排程</MenuItem>
                  <MenuItem value="dispatched">已派發</MenuItem>
                  <MenuItem value="in_progress">進行中</MenuItem>
                  <MenuItem value="completed">已完成</MenuItem>
                </Select>
              </FormControl>
              
              {/* 狀態變更警告 */}
              {statusChangeData.newStatus && statusChangeData.newStatus !== statusChangeData.currentStatus && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  <Typography variant="body2" fontWeight="bold">
                    ⚠️ 狀態變更警告
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {statusChangeData.newStatus === 'completed' && statusChangeData.currentStatus !== 'submitted' && 
                      '⚠️ 將任務標記為「已完成」可能會跳過學生的繳交步驟，請確認學生已完成任務。'
                    }
                    {statusChangeData.newStatus === 'not_dispatched' && statusChangeData.currentStatus === 'in_progress' && 
                      '⚠️ 將任務從「進行中」改為「排程」會重置任務進度，學生需要重新開始。'
                    }
                    {statusChangeData.newStatus === 'dispatched' && statusChangeData.currentStatus === 'completed' && 
                      '⚠️ 將任務從「已完成」改為「已派發」會重置任務狀態，學生需要重新完成。'
                    }
                    {!['completed', 'not_dispatched', 'dispatched'].includes(statusChangeData.newStatus) && 
                      '請確認狀態變更符合實際的任務進度。'
                    }
                  </Typography>
                </Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setShowStatusConfirmDialog(false)}>
            取消
          </Button>
          <Button onClick={handleConfirmStatusChange} variant="contained">
            確定修改
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

// 任務成果視圖
function TaskResultsView({ data, getStatusColor, getStatusText }) {
  const [viewMode, setViewMode] = useState('task'); // 'task' or 'group' (任務視角優先)

  return (
    <Box>
      {/* 視圖切換 */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6">任務成果</Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(e, newMode) => {
            if (newMode !== null) setViewMode(newMode);
          }}
            size="small"
        >
          <ToggleButton value="task">
            <AssignmentIcon sx={{ mr: 1, fontSize: 18 }} />
            任務視角
          </ToggleButton>
          <ToggleButton value="group">
            <ViewListIcon sx={{ mr: 1, fontSize: 18 }} />
            小組視角
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* 說明文字 */}
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          <strong>成果說明：</strong>
          <br />• 學生回覆的成果會以文字形式展示
          <br />• 只有已完成且有繳交成果的任務才會顯示學生回覆
          <br />• 可以從小組或任務兩個角度查看成果
        </Typography>
      </Alert>

      {viewMode === 'task' ? (
        <TaskResultsDetailView data={data} getStatusColor={getStatusColor} getStatusText={getStatusText} />
      ) : (
        <GroupResultsView data={data} getStatusColor={getStatusColor} getStatusText={getStatusText} />
      )}
    </Box>
  );
}

// 小組成果視角
function GroupResultsView({ data, getStatusColor, getStatusText }) {
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const toggleGroupCollapse = (groupId) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  return (
    <Grid container spacing={3}>
      {[...data.groups].sort((a, b) => {
        // 按組別ID排序（確保組別順序一致）
        const idA = parseInt(a.id) || 0;
        const idB = parseInt(b.id) || 0;
        if (idA !== idB) return idA - idB;
        // 如果ID相同，按名稱排序
        const nameA = a.name || a.groupName || '';
        const nameB = b.name || b.groupName || '';
        return nameA.localeCompare(nameB, 'zh-TW');
      }).map((group) => (
        <Grid item xs={12} md={6} lg={4} key={group.id}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" sx={{ color: '#2b687f' }}>
                  {group.name}
                </Typography>
                <Button
                  size="small"
                  onClick={() => toggleGroupCollapse(group.id)}
                  sx={{ 
                    minWidth: 'auto',
                    padding: '4px 8px',
                    fontSize: '0.75rem',
                    color: '#2b687f !important',
                    textTransform: 'none !important'
                  }}
                >
                  {collapsedGroups[group.id] ? '展開' : '收起'}
                </Button>
              </Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                成員: {group.members.map(member => member.name || member).join(', ')}
              </Typography>
              
              {!collapsedGroups[group.id] && (
                <Box sx={{ mt: 2 }}>
                  {data.tasks.filter(task => task.requiresSubmission).map((task) => {
                    const key = `${task.id}_${group.id}`;
                    const cellData = data.matrixStatus[key];
                    const status = cellData?.status || 'not_dispatched';
                    const studentResult = cellData?.studentResult;
                    
                    return (
                      <Box key={task.id} sx={{ mb: 2, p: 2, border: '1px solid #f0f0f0', borderRadius: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                          <Box 
                            sx={{ 
                              width: 12, 
                              height: 12, 
                              backgroundColor: getStatusColor(status),
                              border: '1px solid #ddd',
                              borderRadius: 1
                            }} 
                          />
                          {(() => {
                            // 優先使用直接屬性，若無則從 customizations 取得章節/子任務
                            const unitNumber = task.unit_number ?? task.customizations?.unit_number ?? 1;
                            const subtaskNumber = task.subtask_number ?? task.customizations?.subtask_number ?? '1';
                            return (
                              <Chip
                                label={`${unitNumber}-${subtaskNumber}`}
                                size="small"
                                sx={{
                                  backgroundColor: '#e3f2fd',
                                  color: '#1976d2',
                                  fontSize: '9px',
                                  height: 18,
                                  fontWeight: 500
                                }}
                              />
                            );
                          })()}
                          <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>
                            {task.title}
                          </Typography>
                          <Chip 
                            label={getStatusText(status)} 
                            size="small"
                            sx={{ 
                              backgroundColor: getStatusColor(status),
                              color: '#333',
                              fontSize: '10px'
                            }}
                          />
                        </Box>
                        
                        {studentResult && (
                          <Box sx={{ 
                            mt: 1, 
                            p: 1.5, 
                            backgroundColor: '#f8f9fa', 
                            borderRadius: 1,
                            border: '1px solid #e9ecef'
                          }}>
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                              學生回覆：
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                              {studentResult}
                            </Typography>
                          </Box>
                        )}
                        
                        {!studentResult && status === 'completed' && task.requiresSubmission && (
                          <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                            此任務需要繳交成果，但尚未收到學生回覆
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

// 任務成果詳細視角
function TaskResultsDetailView({ data, getStatusColor, getStatusText }) {
  const [collapsedTasks, setCollapsedTasks] = useState({});

  const toggleTaskCollapse = (taskId) => {
    setCollapsedTasks(prev => ({
      ...prev,
      [taskId]: !prev[taskId]
    }));
  };

  return (
    <Grid container spacing={3}>
      {data.tasks.filter(task => task.requiresSubmission).map((task) => (
        <Grid item xs={12} md={6} lg={4} key={task.id}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6" sx={{ color: '#2b687f' }}>
                  {task.title}
                </Typography>
                <Button
                  size="small"
                  onClick={() => toggleTaskCollapse(task.id)}
                  sx={{ 
                    minWidth: 'auto',
                    padding: '4px 8px',
                    fontSize: '0.75rem',
                    color: '#2b687f !important',
                    textTransform: 'none !important'
                  }}
                >
                  {collapsedTasks[task.id] ? '展開' : '收起'}
                </Button>
              </Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                {task.description}
              </Typography>
              
              {!collapsedTasks[task.id] && (
                <Box sx={{ mt: 2 }}>
                  {[...data.groups].sort((a, b) => {
                    // 按組別ID排序（確保組別順序一致）
                    const idA = parseInt(a.id) || 0;
                    const idB = parseInt(b.id) || 0;
                    if (idA !== idB) return idA - idB;
                    // 如果ID相同，按名稱排序
                    const nameA = a.name || a.groupName || '';
                    const nameB = b.name || b.groupName || '';
                    return nameA.localeCompare(nameB, 'zh-TW');
                  }).map((group) => {
                    const key = `${task.id}_${group.id}`;
                    const cellData = data.matrixStatus[key];
                    const status = cellData?.status || 'not_dispatched';
                    const studentResult = cellData?.studentResult;
                    
                    return (
                      <Box key={group.id} sx={{ mb: 2, p: 2, border: '1px solid #f0f0f0', borderRadius: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          <Box 
                            sx={{ 
                              width: 12, 
                              height: 12, 
                              backgroundColor: getStatusColor(status),
                              border: '1px solid #ddd',
                              borderRadius: 1
                            }} 
                          />
                          <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>
                            {group.name}
                          </Typography>
                          <Chip 
                            label={getStatusText(status)} 
                            size="small"
                            sx={{ 
                              backgroundColor: getStatusColor(status),
                              color: '#333',
                              fontSize: '10px'
                            }}
                          />
                        </Box>
                        
                        {studentResult && (
                          <Box sx={{ 
                            mt: 1, 
                            p: 1.5, 
                            backgroundColor: '#f8f9fa', 
                            borderRadius: 1,
                            border: '1px solid #e9ecef'
                          }}>
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                              學生回覆：
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                              {studentResult}
                            </Typography>
                          </Box>
                        )}
                        
                        {!studentResult && status === 'completed' && task.requiresSubmission && (
                          <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                            此任務需要繳交成果，但尚未收到學生回覆
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

// 單純所有任務與小組視圖
function SimpleTaskGroupView({ data, onCellClick, getStatusColor, getStatusText }) {
  return (
    <Box>
      {/* 狀態圖例 */}
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 3, justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: 16, color: '#666' }} />
          <Typography variant="caption" color="text.secondary">有預定時間</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#fff3e0', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">未完成</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#e8f5e8', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">已完成</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, backgroundColor: '#ffebee', border: '1px solid #ddd' }} />
          <Typography variant="caption" color="text.secondary">遲交</Typography>
        </Box>
      </Box>

      {/* 矩陣表格 */}
      <Card>
        <CardContent sx={{ p: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: 200, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="subtitle2" fontWeight="bold">組別 / 學生</Typography>
                  </TableCell>
                  {data.tasks.map((task) => (
                    <TableCell key={task.id} sx={{ minWidth: 150, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {task.scheduledDate && <CalendarIcon sx={{ fontSize: 16, color: '#666' }} />}
                          <Typography variant="caption" color="text.secondary">
                            {task.scheduledDate ? task.scheduledDate : '- 尚未指派 -'}
                          </Typography>
                        </Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {task.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {task.subtitle}
                        </Typography>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* 小組行 */}
                {[...data.groups].sort((a, b) => {
                  // 按組別ID排序（確保組別順序一致）
                  const idA = parseInt(a.id) || 0;
                  const idB = parseInt(b.id) || 0;
                  if (idA !== idB) return idA - idB;
                  // 如果ID相同，按名稱排序
                  const nameA = a.name || a.groupName || '';
                  const nameB = b.name || b.groupName || '';
                  return nameA.localeCompare(nameB, 'zh-TW');
                }).map((group) => (
                  <TableRow key={group.id}>
                    <TableCell sx={{ backgroundColor: '#f8f9fa' }}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {group.name}
                      </Typography>
                      <Box sx={{ mt: 0.5 }}>
                        {group.members.map((member, index) => (
                          <Typography key={index} variant="caption" color="text.secondary" display="block">
                            {member}
                          </Typography>
                        ))}
                      </Box>
                    </TableCell>
                    {data.tasks.map((task) => {
                      const key = `${task.id}_${group.id}`;
                      const cellData = data.matrixStatus[key];
                      const status = cellData?.status || 'not_dispatched';
                      const progress = cellData?.progress;
                      
                      return (
                        <TableCell 
                          key={key} 
                          sx={{ 
                            textAlign: 'center', 
                            backgroundColor: getStatusColor(status),
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: status === 'not_dispatched' ? '#e0e0e0' : getStatusColor(status),
                              opacity: 0.8
                            }
                          }}
                          onClick={() => handleCellClickWithConfirm(task.id, group.id)}
                        >
                          {status === 'not_dispatched' ? (
                            <AddIcon sx={{ color: '#999', fontSize: 20 }} />
                          ) : (
                            <Box>
                              {progress && (
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    fontWeight: 'bold',
                                    color: status === 'in_progress' ? '#ff9800' : 
                                           status === 'completed' ? '#4caf50' : '#666'
                                  }}
                                >
                                  {progress}
                                </Typography>
                              )}
                              <Typography variant="caption" display="block" color="text.secondary">
                                {getStatusText(status)}
                              </Typography>
                            </Box>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}

// 多對多批次派發任務視圖
function BatchDispatchView({ 
  data, 
  selectedTasks, 
  selectedGroups, 
  onTaskSelect, 
  onGroupSelect, 
  onDispatchTasks, 
  onCellClick, 
  getStatusColor, 
  getStatusText 
}) {
  return (
    <Box>
      {/* 操作按鈕區域 */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Button
          variant="contained"
          className="btn-primary"
          startIcon={<SendIcon />}
          onClick={onDispatchTasks}
          disabled={selectedTasks.length === 0 || selectedGroups.length === 0}
        >
          指派全班/組別 ({selectedTasks.length} 任務 → {selectedGroups.length} 小組)
        </Button>
        
        {/* 狀態圖例 */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarIcon sx={{ fontSize: 16, color: '#666' }} />
            <Typography variant="caption" color="text.secondary">有預定時間</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#fff3e0', border: '1px solid #ddd' }} />
            <Typography variant="caption" color="text.secondary">未完成</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 12, height: 12, backgroundColor: '#e8f5e8', border: '1px solid #ddd' }} />
            <Typography variant="caption" color="text.secondary">已完成</Typography>
          </Box>
        </Box>
      </Box>

      {/* 矩陣表格 */}
      <Card>
        <CardContent sx={{ p: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: 200, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="subtitle2" fontWeight="bold">組別 / 學生</Typography>
                  </TableCell>
                  {data.tasks.map((task) => (
                    <TableCell key={task.id} sx={{ minWidth: 150, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={selectedTasks.includes(task.id)}
                          onChange={() => onTaskSelect(task.id)}
                          size="small"
                        />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {task.scheduledDate && <CalendarIcon sx={{ fontSize: 16, color: '#666' }} />}
                          <Typography variant="caption" color="text.secondary">
                            {task.scheduledDate ? task.scheduledDate : '- 尚未指派 -'}
                          </Typography>
                        </Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {task.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {task.subtitle}
                        </Typography>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* 小組行 */}
                {[...data.groups].sort((a, b) => {
                  // 按組別ID排序（確保組別順序一致）
                  const idA = parseInt(a.id) || 0;
                  const idB = parseInt(b.id) || 0;
                  if (idA !== idB) return idA - idB;
                  // 如果ID相同，按名稱排序
                  const nameA = a.name || a.groupName || '';
                  const nameB = b.name || b.groupName || '';
                  return nameA.localeCompare(nameB, 'zh-TW');
                }).map((group) => (
                  <TableRow key={group.id}>
                    <TableCell sx={{ backgroundColor: '#f8f9fa' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={selectedGroups.includes(group.id)}
                          onChange={() => onGroupSelect(group.id)}
                          size="small"
                        />
                        <Typography variant="subtitle2" fontWeight="bold">
                          {group.name}
                        </Typography>
                      </Box>
                      <Box sx={{ ml: 4, mt: 0.5 }}>
                        {group.members.map((member, index) => (
                          <Typography key={index} variant="caption" color="text.secondary" display="block">
                            {member}
                          </Typography>
                        ))}
                      </Box>
                    </TableCell>
                    {data.tasks.map((task) => {
                      const key = `${task.id}_${group.id}`;
                      const cellData = data.matrixStatus[key];
                      const status = cellData?.status || 'not_dispatched';
                      const progress = cellData?.progress;
                      
                      return (
                        <TableCell 
                          key={key} 
                          sx={{ 
                            textAlign: 'center', 
                            backgroundColor: getStatusColor(status),
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: status === 'not_dispatched' ? '#e0e0e0' : getStatusColor(status),
                              opacity: 0.8
                            }
                          }}
                          onClick={() => handleCellClickWithConfirm(task.id, group.id)}
                        >
                          {status === 'not_dispatched' ? (
                            <AddIcon sx={{ color: '#999', fontSize: 20 }} />
                          ) : (
                            <Box>
                              {progress && (
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    fontWeight: 'bold',
                                    color: status === 'in_progress' ? '#ff9800' : 
                                           status === 'completed' ? '#4caf50' : '#666'
                                  }}
                                >
                                  {progress}
                                </Typography>
                              )}
                              <Typography variant="caption" display="block" color="text.secondary">
                                {getStatusText(status)}
                              </Typography>
                            </Box>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}

// 任務管理視圖
function TaskManagementView({ data, onCreateTask, onManageTask }) {
  const [editingTask, setEditingTask] = useState(null);
  const [tasks, setTasks] = useState(data.tasks);

  const handleEditTask = (task) => {
    setEditingTask(task);
  };

  const handleDeleteTask = (taskId) => {
    if (window.confirm('確定要刪除這個任務嗎？')) {
      setTasks(tasks.filter(task => task.id !== taskId));
    }
  };

  const handleSaveTask = () => {
    if (editingTask) {
      setTasks(tasks.map(task =>
        task.id === editingTask.id ? editingTask : task
      ));
      setEditingTask(null);
    }
  };

  const handleDragStart = (e, taskId) => {
    e.dataTransfer.setData('text/plain', taskId);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetTaskId) => {
    e.preventDefault();
    const draggedTaskId = e.dataTransfer.getData('text/plain');
    
    if (draggedTaskId !== targetTaskId) {
      const draggedIndex = tasks.findIndex(task => task.id === parseInt(draggedTaskId));
      const targetIndex = tasks.findIndex(task => task.id === targetTaskId);
      
      const newTasks = [...tasks];
      const [draggedTask] = newTasks.splice(draggedIndex, 1);
      newTasks.splice(targetIndex, 0, draggedTask);
      
      setTasks(newTasks);
    }
  };

  return (
    <Box>
      {/* 操作按鈕區域 */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button
          variant="contained"
          className="btn-primary"
          startIcon={<AddIcon />}
          onClick={onCreateTask}
        >
          建立任務 +
        </Button>
        <Button
          variant="outlined"
          className="btn-secondary"
          startIcon={<EditIcon />}
          onClick={onManageTask}
        >
          管理任務
        </Button>
      </Box>

      {/* 任務列表 */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            任務列表 ({tasks.length})
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="40px">拖曳</TableCell>
                  <TableCell>任務標題</TableCell>
                  <TableCell>副標題</TableCell>
                  <TableCell>預定日期</TableCell>
                  <TableCell>狀態</TableCell>
                  <TableCell>操作</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tasks.map((task) => (
                  <TableRow 
                    key={task.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, task.id)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, task.id)}
                    sx={{ cursor: 'move' }}
                  >
                    <TableCell>
                      <DragIndicatorIcon sx={{ color: '#999' }} />
                    </TableCell>
                    <TableCell>
                      {editingTask?.id === task.id ? (
                        <TextField
                          value={editingTask.title}
                          onChange={(e) => setEditingTask({ ...editingTask, title: e.target.value })}
                          size="small"
                          fullWidth
                        />
                      ) : (
                        task.title
                      )}
                    </TableCell>
                    <TableCell>
                      {editingTask?.id === task.id ? (
                        <TextField
                          value={editingTask.subtitle}
                          onChange={(e) => setEditingTask({ ...editingTask, subtitle: e.target.value })}
                          size="small"
                          fullWidth
                        />
                      ) : (
                        task.subtitle
                      )}
                    </TableCell>
                    <TableCell>
                      {editingTask?.id === task.id ? (
                        <TextField
                          type="date"
                          value={editingTask.scheduledDate || ''}
                          onChange={(e) => setEditingTask({ ...editingTask, scheduledDate: e.target.value })}
                          size="small"
                          InputLabelProps={{ shrink: true }}
                        />
                      ) : (
                        task.scheduledDate || '-'
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={task.status === 'assigned' ? '已指派' : '未指派'}
                        color={task.status === 'assigned' ? 'success' : 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      {editingTask?.id === task.id ? (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button size="small" onClick={handleSaveTask} className="btn-primary">
                            保存
                          </Button>
                          <Button size="small" onClick={() => setEditingTask(null)}>
                            取消
                          </Button>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton size="small" onClick={() => handleEditTask(task)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleDeleteTask(task.id)} sx={{ color: '#f44336' }}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}

// 建立任務對話框
function CreateTaskDialog({ open, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    description: '',
    scheduledDate: ''
  });

  const handleSubmit = () => {
    if (!formData.title || !formData.subtitle) {
      onSuccess('請填寫必要欄位');
      return;
    }
    
    // 這裡應該調用 API 創建任務
    onSuccess('任務建立成功');
    setFormData({ title: '', subtitle: '', description: '', scheduledDate: '' });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>建立新任務</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="任務標題"
            value={formData.title}
            onChange={(e) => {
              const value = e.target.value || '';
              if (value.length <= 15) {
                setFormData({ ...formData, title: value });
              }
            }}
            fullWidth
            required
            helperText={`${Math.min((formData.title || '').length, 15)}/15 字`}
            inputProps={{ maxLength: 15 }}
          />
          <TextField
            label="任務副標題"
            value={formData.subtitle}
            onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
            fullWidth
            required
          />
          <TextField
            label="任務描述"
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            multiline
            rows={3}
            fullWidth
          />
          <TextField
            label="預定日期"
            type="date"
            value={formData.scheduledDate}
            onChange={(e) => setFormData({ ...formData, scheduledDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={onClose}>取消</Button>
        <Button onClick={handleSubmit} variant="contained">
          建立任務
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// 管理任務對話框
function ManageTaskDialog({ open, onClose, tasks, onSuccess }) {
  const [editingTask, setEditingTask] = useState(null);

  const handleEditTask = (task) => {
    setEditingTask(task);
  };

  const handleDeleteTask = (taskId) => {
    if (window.confirm('確定要刪除這個任務嗎？')) {
      // 這裡應該調用 API 刪除任務
      onSuccess('任務已刪除');
    }
  };

  const handleSaveTask = () => {
    // 這裡應該調用 API 更新任務
    onSuccess('任務已更新');
    setEditingTask(null);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>管理任務</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>任務標題</TableCell>
                <TableCell>副標題</TableCell>
                <TableCell>預定日期</TableCell>
                <TableCell>狀態</TableCell>
                <TableCell>操作</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((task) => (
                <TableRow key={task.id}>
                  <TableCell>
                    {editingTask?.id === task.id ? (
                      <TextField
                        value={editingTask.title}
                        onChange={(e) => setEditingTask({ ...editingTask, title: e.target.value })}
                        size="small"
                        fullWidth
                      />
                    ) : (
                      task.title
                    )}
                  </TableCell>
                  <TableCell>
                    {editingTask?.id === task.id ? (
                      <TextField
                        value={editingTask.subtitle}
                        onChange={(e) => setEditingTask({ ...editingTask, subtitle: e.target.value })}
                        size="small"
                        fullWidth
                      />
                    ) : (
                      task.subtitle
                    )}
                  </TableCell>
                  <TableCell>
                    {editingTask?.id === task.id ? (
                      <TextField
                        type="date"
                        value={editingTask.scheduledDate || ''}
                        onChange={(e) => setEditingTask({ ...editingTask, scheduledDate: e.target.value })}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                    ) : (
                      task.scheduledDate || '-'
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={task.status === 'assigned' ? '已指派' : '未指派'}
                      color={task.status === 'assigned' ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {editingTask?.id === task.id ? (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button size="small" onClick={handleSaveTask} className="btn-primary">
                          保存
                        </Button>
                        <Button size="small" onClick={() => setEditingTask(null)}>
                          取消
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton size="small" onClick={() => handleEditTask(task)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDeleteTask(task.id)} sx={{ color: '#f44336' }}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={onClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
}
